var as = Object.defineProperty;
var ss = (t, e, r) => e in t ? as(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var re = (t, e, r) => ss(t, typeof e != "symbol" ? e + "" : e, r);
var V = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ot(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function cs(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
var $r = { exports: {} };
$r.exports;
(function(t, e) {
  var r = 200, n = "__lodash_hash_undefined__", i = 9007199254740991, a = "[object Arguments]", s = "[object Array]", u = "[object Boolean]", d = "[object Date]", p = "[object Error]", m = "[object Function]", P = "[object GeneratorFunction]", T = "[object Map]", A = "[object Number]", O = "[object Object]", E = "[object Promise]", x = "[object RegExp]", w = "[object Set]", b = "[object String]", l = "[object Symbol]", f = "[object WeakMap]", g = "[object ArrayBuffer]", h = "[object DataView]", _ = "[object Float32Array]", K = "[object Float64Array]", U = "[object Int8Array]", X = "[object Int16Array]", we = "[object Int32Array]", ne = "[object Uint8Array]", J = "[object Uint8ClampedArray]", se = "[object Uint16Array]", ce = "[object Uint32Array]", xe = /[\\^$.*+?()[\]{}|]/g, Ue = /\w*$/, _t = /^\[object .+?Constructor\]$/, rt = /^(?:0|[1-9]\d*)$/, R = {};
  R[a] = R[s] = R[g] = R[h] = R[u] = R[d] = R[_] = R[K] = R[U] = R[X] = R[we] = R[T] = R[A] = R[O] = R[x] = R[w] = R[b] = R[l] = R[ne] = R[J] = R[se] = R[ce] = !0, R[p] = R[m] = R[f] = !1;
  var fn = typeof V == "object" && V && V.Object === Object && V, pn = typeof self == "object" && self && self.Object === Object && self, pe = fn || pn || Function("return this")(), ur = e && !e.nodeType && e, F = ur && !0 && t && !t.nodeType && t, lr = F && F.exports === ur;
  function dn(o, c) {
    return o.set(c[0], c[1]), o;
  }
  function de(o, c) {
    return o.add(c), o;
  }
  function fr(o, c) {
    for (var y = -1, v = o ? o.length : 0; ++y < v && c(o[y], y, o) !== !1; )
      ;
    return o;
  }
  function pr(o, c) {
    for (var y = -1, v = c.length, C = o.length; ++y < v; )
      o[C + y] = c[y];
    return o;
  }
  function Ct(o, c, y, v) {
    for (var C = -1, M = o ? o.length : 0; ++C < M; )
      y = c(y, o[C], C, o);
    return y;
  }
  function Nt(o, c) {
    for (var y = -1, v = Array(o); ++y < o; )
      v[y] = c(y);
    return v;
  }
  function dr(o, c) {
    return o == null ? void 0 : o[c];
  }
  function It(o) {
    var c = !1;
    if (o != null && typeof o.toString != "function")
      try {
        c = !!(o + "");
      } catch {
      }
    return c;
  }
  function hr(o) {
    var c = -1, y = Array(o.size);
    return o.forEach(function(v, C) {
      y[++c] = [C, v];
    }), y;
  }
  function Dt(o, c) {
    return function(y) {
      return o(c(y));
    };
  }
  function yr(o) {
    var c = -1, y = Array(o.size);
    return o.forEach(function(v) {
      y[++c] = v;
    }), y;
  }
  var hn = Array.prototype, yn = Function.prototype, nt = Object.prototype, Rt = pe["__core-js_shared__"], mr = function() {
    var o = /[^.]+$/.exec(Rt && Rt.keys && Rt.keys.IE_PROTO || "");
    return o ? "Symbol(src)_1." + o : "";
  }(), gr = yn.toString, Se = nt.hasOwnProperty, ot = nt.toString, mn = RegExp(
    "^" + gr.call(Se).replace(xe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Ge = lr ? pe.Buffer : void 0, it = pe.Symbol, Lt = pe.Uint8Array, ue = Dt(Object.getPrototypeOf, Object), br = Object.create, wr = nt.propertyIsEnumerable, gn = hn.splice, jt = Object.getOwnPropertySymbols, at = Ge ? Ge.isBuffer : void 0, Sr = Dt(Object.keys, Object), st = ye(pe, "DataView"), Ze = ye(pe, "Map"), he = ye(pe, "Promise"), ct = ye(pe, "Set"), Kt = ye(pe, "WeakMap"), ze = ye(Object, "create"), Ft = te(st), He = te(Ze), Ut = te(he), Gt = te(ct), Zt = te(Kt), Ie = it ? it.prototype : void 0, vr = Ie ? Ie.valueOf : void 0;
  function Me(o) {
    var c = -1, y = o ? o.length : 0;
    for (this.clear(); ++c < y; ) {
      var v = o[c];
      this.set(v[0], v[1]);
    }
  }
  function bn() {
    this.__data__ = ze ? ze(null) : {};
  }
  function wn(o) {
    return this.has(o) && delete this.__data__[o];
  }
  function Sn(o) {
    var c = this.__data__;
    if (ze) {
      var y = c[o];
      return y === n ? void 0 : y;
    }
    return Se.call(c, o) ? c[o] : void 0;
  }
  function Pr(o) {
    var c = this.__data__;
    return ze ? c[o] !== void 0 : Se.call(c, o);
  }
  function zt(o, c) {
    var y = this.__data__;
    return y[o] = ze && c === void 0 ? n : c, this;
  }
  Me.prototype.clear = bn, Me.prototype.delete = wn, Me.prototype.get = Sn, Me.prototype.has = Pr, Me.prototype.set = zt;
  function k(o) {
    var c = -1, y = o ? o.length : 0;
    for (this.clear(); ++c < y; ) {
      var v = o[c];
      this.set(v[0], v[1]);
    }
  }
  function vn() {
    this.__data__ = [];
  }
  function Pn(o) {
    var c = this.__data__, y = lt(c, o);
    if (y < 0)
      return !1;
    var v = c.length - 1;
    return y == v ? c.pop() : gn.call(c, y, 1), !0;
  }
  function On(o) {
    var c = this.__data__, y = lt(c, o);
    return y < 0 ? void 0 : c[y][1];
  }
  function Tn(o) {
    return lt(this.__data__, o) > -1;
  }
  function An(o, c) {
    var y = this.__data__, v = lt(y, o);
    return v < 0 ? y.push([o, c]) : y[v][1] = c, this;
  }
  k.prototype.clear = vn, k.prototype.delete = Pn, k.prototype.get = On, k.prototype.has = Tn, k.prototype.set = An;
  function Y(o) {
    var c = -1, y = o ? o.length : 0;
    for (this.clear(); ++c < y; ) {
      var v = o[c];
      this.set(v[0], v[1]);
    }
  }
  function En() {
    this.__data__ = {
      hash: new Me(),
      map: new (Ze || k)(),
      string: new Me()
    };
  }
  function xn(o) {
    return Xe(this, o).delete(o);
  }
  function Mn(o) {
    return Xe(this, o).get(o);
  }
  function _n(o) {
    return Xe(this, o).has(o);
  }
  function Cn(o, c) {
    return Xe(this, o).set(o, c), this;
  }
  Y.prototype.clear = En, Y.prototype.delete = xn, Y.prototype.get = Mn, Y.prototype.has = _n, Y.prototype.set = Cn;
  function oe(o) {
    this.__data__ = new k(o);
  }
  function Nn() {
    this.__data__ = new k();
  }
  function In(o) {
    return this.__data__.delete(o);
  }
  function Dn(o) {
    return this.__data__.get(o);
  }
  function Rn(o) {
    return this.__data__.has(o);
  }
  function Ln(o, c) {
    var y = this.__data__;
    if (y instanceof k) {
      var v = y.__data__;
      if (!Ze || v.length < r - 1)
        return v.push([o, c]), this;
      y = this.__data__ = new Y(v);
    }
    return y.set(o, c), this;
  }
  oe.prototype.clear = Nn, oe.prototype.delete = In, oe.prototype.get = Dn, oe.prototype.has = Rn, oe.prototype.set = Ln;
  function ut(o, c) {
    var y = $t(o) || pt(o) ? Nt(o.length, String) : [], v = y.length, C = !!v;
    for (var M in o)
      Se.call(o, M) && !(C && (M == "length" || Vn(M, v))) && y.push(M);
    return y;
  }
  function Or(o, c, y) {
    var v = o[c];
    (!(Se.call(o, c) && Mr(v, y)) || y === void 0 && !(c in o)) && (o[c] = y);
  }
  function lt(o, c) {
    for (var y = o.length; y--; )
      if (Mr(o[y][0], c))
        return y;
    return -1;
  }
  function ve(o, c) {
    return o && Xt(c, Wt(c), o);
  }
  function Ht(o, c, y, v, C, M, L) {
    var D;
    if (v && (D = M ? v(o, C, M, L) : v(o)), D !== void 0)
      return D;
    if (!Oe(o))
      return o;
    var z = $t(o);
    if (z) {
      if (D = kn(o), !c)
        return Bn(o, D);
    } else {
      var j = Ce(o), Q = j == m || j == P;
      if (_r(o))
        return ft(o, c);
      if (j == O || j == a || Q && !M) {
        if (It(o))
          return M ? o : {};
        if (D = Pe(Q ? {} : o), !c)
          return Xn(o, ve(D, o));
      } else {
        if (!R[j])
          return M ? o : {};
        D = Wn(o, j, Ht, c);
      }
    }
    L || (L = new oe());
    var ie = L.get(o);
    if (ie)
      return ie;
    if (L.set(o, D), !z)
      var H = y ? $n(o) : Wt(o);
    return fr(H || o, function(q, W) {
      H && (W = q, q = o[W]), Or(D, W, Ht(q, c, y, v, W, o, L));
    }), D;
  }
  function jn(o) {
    return Oe(o) ? br(o) : {};
  }
  function Kn(o, c, y) {
    var v = c(o);
    return $t(o) ? v : pr(v, y(o));
  }
  function Fn(o) {
    return ot.call(o);
  }
  function Un(o) {
    if (!Oe(o) || Yn(o))
      return !1;
    var c = kt(o) || It(o) ? mn : _t;
    return c.test(te(o));
  }
  function Gn(o) {
    if (!Er(o))
      return Sr(o);
    var c = [];
    for (var y in Object(o))
      Se.call(o, y) && y != "constructor" && c.push(y);
    return c;
  }
  function ft(o, c) {
    if (c)
      return o.slice();
    var y = new o.constructor(o.length);
    return o.copy(y), y;
  }
  function Bt(o) {
    var c = new o.constructor(o.byteLength);
    return new Lt(c).set(new Lt(o)), c;
  }
  function Be(o, c) {
    var y = c ? Bt(o.buffer) : o.buffer;
    return new o.constructor(y, o.byteOffset, o.byteLength);
  }
  function Tr(o, c, y) {
    var v = c ? y(hr(o), !0) : hr(o);
    return Ct(v, dn, new o.constructor());
  }
  function Ar(o) {
    var c = new o.constructor(o.source, Ue.exec(o));
    return c.lastIndex = o.lastIndex, c;
  }
  function Zn(o, c, y) {
    var v = c ? y(yr(o), !0) : yr(o);
    return Ct(v, de, new o.constructor());
  }
  function zn(o) {
    return vr ? Object(vr.call(o)) : {};
  }
  function Hn(o, c) {
    var y = c ? Bt(o.buffer) : o.buffer;
    return new o.constructor(y, o.byteOffset, o.length);
  }
  function Bn(o, c) {
    var y = -1, v = o.length;
    for (c || (c = Array(v)); ++y < v; )
      c[y] = o[y];
    return c;
  }
  function Xt(o, c, y, v) {
    y || (y = {});
    for (var C = -1, M = c.length; ++C < M; ) {
      var L = c[C], D = void 0;
      Or(y, L, D === void 0 ? o[L] : D);
    }
    return y;
  }
  function Xn(o, c) {
    return Xt(o, _e(o), c);
  }
  function $n(o) {
    return Kn(o, Wt, _e);
  }
  function Xe(o, c) {
    var y = o.__data__;
    return Jn(c) ? y[typeof c == "string" ? "string" : "hash"] : y.map;
  }
  function ye(o, c) {
    var y = dr(o, c);
    return Un(y) ? y : void 0;
  }
  var _e = jt ? Dt(jt, Object) : qn, Ce = Fn;
  (st && Ce(new st(new ArrayBuffer(1))) != h || Ze && Ce(new Ze()) != T || he && Ce(he.resolve()) != E || ct && Ce(new ct()) != w || Kt && Ce(new Kt()) != f) && (Ce = function(o) {
    var c = ot.call(o), y = c == O ? o.constructor : void 0, v = y ? te(y) : void 0;
    if (v)
      switch (v) {
        case Ft:
          return h;
        case He:
          return T;
        case Ut:
          return E;
        case Gt:
          return w;
        case Zt:
          return f;
      }
    return c;
  });
  function kn(o) {
    var c = o.length, y = o.constructor(c);
    return c && typeof o[0] == "string" && Se.call(o, "index") && (y.index = o.index, y.input = o.input), y;
  }
  function Pe(o) {
    return typeof o.constructor == "function" && !Er(o) ? jn(ue(o)) : {};
  }
  function Wn(o, c, y, v) {
    var C = o.constructor;
    switch (c) {
      case g:
        return Bt(o);
      case u:
      case d:
        return new C(+o);
      case h:
        return Be(o, v);
      case _:
      case K:
      case U:
      case X:
      case we:
      case ne:
      case J:
      case se:
      case ce:
        return Hn(o, v);
      case T:
        return Tr(o, v, y);
      case A:
      case b:
        return new C(o);
      case x:
        return Ar(o);
      case w:
        return Zn(o, v, y);
      case l:
        return zn(o);
    }
  }
  function Vn(o, c) {
    return c = c ?? i, !!c && (typeof o == "number" || rt.test(o)) && o > -1 && o % 1 == 0 && o < c;
  }
  function Jn(o) {
    var c = typeof o;
    return c == "string" || c == "number" || c == "symbol" || c == "boolean" ? o !== "__proto__" : o === null;
  }
  function Yn(o) {
    return !!mr && mr in o;
  }
  function Er(o) {
    var c = o && o.constructor, y = typeof c == "function" && c.prototype || nt;
    return o === y;
  }
  function te(o) {
    if (o != null) {
      try {
        return gr.call(o);
      } catch {
      }
      try {
        return o + "";
      } catch {
      }
    }
    return "";
  }
  function xr(o) {
    return Ht(o, !0, !0);
  }
  function Mr(o, c) {
    return o === c || o !== o && c !== c;
  }
  function pt(o) {
    return Qn(o) && Se.call(o, "callee") && (!wr.call(o, "callee") || ot.call(o) == a);
  }
  var $t = Array.isArray;
  function dt(o) {
    return o != null && Cr(o.length) && !kt(o);
  }
  function Qn(o) {
    return Nr(o) && dt(o);
  }
  var _r = at || eo;
  function kt(o) {
    var c = Oe(o) ? ot.call(o) : "";
    return c == m || c == P;
  }
  function Cr(o) {
    return typeof o == "number" && o > -1 && o % 1 == 0 && o <= i;
  }
  function Oe(o) {
    var c = typeof o;
    return !!o && (c == "object" || c == "function");
  }
  function Nr(o) {
    return !!o && typeof o == "object";
  }
  function Wt(o) {
    return dt(o) ? ut(o) : Gn(o);
  }
  function qn() {
    return [];
  }
  function eo() {
    return !1;
  }
  t.exports = xr;
})($r, $r.exports);
var us = $r.exports;
const ls = /* @__PURE__ */ Ot(us);
var kr = { exports: {} };
kr.exports;
(function(t, e) {
  var r = 200, n = "__lodash_hash_undefined__", i = 1, a = 2, s = 9007199254740991, u = "[object Arguments]", d = "[object Array]", p = "[object AsyncFunction]", m = "[object Boolean]", P = "[object Date]", T = "[object Error]", A = "[object Function]", O = "[object GeneratorFunction]", E = "[object Map]", x = "[object Number]", w = "[object Null]", b = "[object Object]", l = "[object Promise]", f = "[object Proxy]", g = "[object RegExp]", h = "[object Set]", _ = "[object String]", K = "[object Symbol]", U = "[object Undefined]", X = "[object WeakMap]", we = "[object ArrayBuffer]", ne = "[object DataView]", J = "[object Float32Array]", se = "[object Float64Array]", ce = "[object Int8Array]", xe = "[object Int16Array]", Ue = "[object Int32Array]", _t = "[object Uint8Array]", rt = "[object Uint8ClampedArray]", R = "[object Uint16Array]", fn = "[object Uint32Array]", pn = /[\\^$.*+?()[\]{}|]/g, pe = /^\[object .+?Constructor\]$/, ur = /^(?:0|[1-9]\d*)$/, F = {};
  F[J] = F[se] = F[ce] = F[xe] = F[Ue] = F[_t] = F[rt] = F[R] = F[fn] = !0, F[u] = F[d] = F[we] = F[m] = F[ne] = F[P] = F[T] = F[A] = F[E] = F[x] = F[b] = F[g] = F[h] = F[_] = F[X] = !1;
  var lr = typeof V == "object" && V && V.Object === Object && V, dn = typeof self == "object" && self && self.Object === Object && self, de = lr || dn || Function("return this")(), fr = e && !e.nodeType && e, pr = fr && !0 && t && !t.nodeType && t, Ct = pr && pr.exports === fr, Nt = Ct && lr.process, dr = function() {
    try {
      return Nt && Nt.binding && Nt.binding("util");
    } catch {
    }
  }(), It = dr && dr.isTypedArray;
  function hr(o, c) {
    for (var y = -1, v = o == null ? 0 : o.length, C = 0, M = []; ++y < v; ) {
      var L = o[y];
      c(L, y, o) && (M[C++] = L);
    }
    return M;
  }
  function Dt(o, c) {
    for (var y = -1, v = c.length, C = o.length; ++y < v; )
      o[C + y] = c[y];
    return o;
  }
  function yr(o, c) {
    for (var y = -1, v = o == null ? 0 : o.length; ++y < v; )
      if (c(o[y], y, o))
        return !0;
    return !1;
  }
  function hn(o, c) {
    for (var y = -1, v = Array(o); ++y < o; )
      v[y] = c(y);
    return v;
  }
  function yn(o) {
    return function(c) {
      return o(c);
    };
  }
  function nt(o, c) {
    return o.has(c);
  }
  function Rt(o, c) {
    return o == null ? void 0 : o[c];
  }
  function mr(o) {
    var c = -1, y = Array(o.size);
    return o.forEach(function(v, C) {
      y[++c] = [C, v];
    }), y;
  }
  function gr(o, c) {
    return function(y) {
      return o(c(y));
    };
  }
  function Se(o) {
    var c = -1, y = Array(o.size);
    return o.forEach(function(v) {
      y[++c] = v;
    }), y;
  }
  var ot = Array.prototype, mn = Function.prototype, Ge = Object.prototype, it = de["__core-js_shared__"], Lt = mn.toString, ue = Ge.hasOwnProperty, br = function() {
    var o = /[^.]+$/.exec(it && it.keys && it.keys.IE_PROTO || "");
    return o ? "Symbol(src)_1." + o : "";
  }(), wr = Ge.toString, gn = RegExp(
    "^" + Lt.call(ue).replace(pn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), jt = Ct ? de.Buffer : void 0, at = de.Symbol, Sr = de.Uint8Array, st = Ge.propertyIsEnumerable, Ze = ot.splice, he = at ? at.toStringTag : void 0, ct = Object.getOwnPropertySymbols, Kt = jt ? jt.isBuffer : void 0, ze = gr(Object.keys, Object), Ft = _e(de, "DataView"), He = _e(de, "Map"), Ut = _e(de, "Promise"), Gt = _e(de, "Set"), Zt = _e(de, "WeakMap"), Ie = _e(Object, "create"), vr = te(Ft), Me = te(He), bn = te(Ut), wn = te(Gt), Sn = te(Zt), Pr = at ? at.prototype : void 0, zt = Pr ? Pr.valueOf : void 0;
  function k(o) {
    var c = -1, y = o == null ? 0 : o.length;
    for (this.clear(); ++c < y; ) {
      var v = o[c];
      this.set(v[0], v[1]);
    }
  }
  function vn() {
    this.__data__ = Ie ? Ie(null) : {}, this.size = 0;
  }
  function Pn(o) {
    var c = this.has(o) && delete this.__data__[o];
    return this.size -= c ? 1 : 0, c;
  }
  function On(o) {
    var c = this.__data__;
    if (Ie) {
      var y = c[o];
      return y === n ? void 0 : y;
    }
    return ue.call(c, o) ? c[o] : void 0;
  }
  function Tn(o) {
    var c = this.__data__;
    return Ie ? c[o] !== void 0 : ue.call(c, o);
  }
  function An(o, c) {
    var y = this.__data__;
    return this.size += this.has(o) ? 0 : 1, y[o] = Ie && c === void 0 ? n : c, this;
  }
  k.prototype.clear = vn, k.prototype.delete = Pn, k.prototype.get = On, k.prototype.has = Tn, k.prototype.set = An;
  function Y(o) {
    var c = -1, y = o == null ? 0 : o.length;
    for (this.clear(); ++c < y; ) {
      var v = o[c];
      this.set(v[0], v[1]);
    }
  }
  function En() {
    this.__data__ = [], this.size = 0;
  }
  function xn(o) {
    var c = this.__data__, y = ft(c, o);
    if (y < 0)
      return !1;
    var v = c.length - 1;
    return y == v ? c.pop() : Ze.call(c, y, 1), --this.size, !0;
  }
  function Mn(o) {
    var c = this.__data__, y = ft(c, o);
    return y < 0 ? void 0 : c[y][1];
  }
  function _n(o) {
    return ft(this.__data__, o) > -1;
  }
  function Cn(o, c) {
    var y = this.__data__, v = ft(y, o);
    return v < 0 ? (++this.size, y.push([o, c])) : y[v][1] = c, this;
  }
  Y.prototype.clear = En, Y.prototype.delete = xn, Y.prototype.get = Mn, Y.prototype.has = _n, Y.prototype.set = Cn;
  function oe(o) {
    var c = -1, y = o == null ? 0 : o.length;
    for (this.clear(); ++c < y; ) {
      var v = o[c];
      this.set(v[0], v[1]);
    }
  }
  function Nn() {
    this.size = 0, this.__data__ = {
      hash: new k(),
      map: new (He || Y)(),
      string: new k()
    };
  }
  function In(o) {
    var c = ye(this, o).delete(o);
    return this.size -= c ? 1 : 0, c;
  }
  function Dn(o) {
    return ye(this, o).get(o);
  }
  function Rn(o) {
    return ye(this, o).has(o);
  }
  function Ln(o, c) {
    var y = ye(this, o), v = y.size;
    return y.set(o, c), this.size += y.size == v ? 0 : 1, this;
  }
  oe.prototype.clear = Nn, oe.prototype.delete = In, oe.prototype.get = Dn, oe.prototype.has = Rn, oe.prototype.set = Ln;
  function ut(o) {
    var c = -1, y = o == null ? 0 : o.length;
    for (this.__data__ = new oe(); ++c < y; )
      this.add(o[c]);
  }
  function Or(o) {
    return this.__data__.set(o, n), this;
  }
  function lt(o) {
    return this.__data__.has(o);
  }
  ut.prototype.add = ut.prototype.push = Or, ut.prototype.has = lt;
  function ve(o) {
    var c = this.__data__ = new Y(o);
    this.size = c.size;
  }
  function Ht() {
    this.__data__ = new Y(), this.size = 0;
  }
  function jn(o) {
    var c = this.__data__, y = c.delete(o);
    return this.size = c.size, y;
  }
  function Kn(o) {
    return this.__data__.get(o);
  }
  function Fn(o) {
    return this.__data__.has(o);
  }
  function Un(o, c) {
    var y = this.__data__;
    if (y instanceof Y) {
      var v = y.__data__;
      if (!He || v.length < r - 1)
        return v.push([o, c]), this.size = ++y.size, this;
      y = this.__data__ = new oe(v);
    }
    return y.set(o, c), this.size = y.size, this;
  }
  ve.prototype.clear = Ht, ve.prototype.delete = jn, ve.prototype.get = Kn, ve.prototype.has = Fn, ve.prototype.set = Un;
  function Gn(o, c) {
    var y = pt(o), v = !y && Mr(o), C = !y && !v && dt(o), M = !y && !v && !C && Nr(o), L = y || v || C || M, D = L ? hn(o.length, String) : [], z = D.length;
    for (var j in o)
      ue.call(o, j) && !(L && // Safari 9 has enumerable `arguments.length` in strict mode.
      (j == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      C && (j == "offset" || j == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      M && (j == "buffer" || j == "byteLength" || j == "byteOffset") || // Skip index properties.
      Wn(j, z))) && D.push(j);
    return D;
  }
  function ft(o, c) {
    for (var y = o.length; y--; )
      if (xr(o[y][0], c))
        return y;
    return -1;
  }
  function Bt(o, c, y) {
    var v = c(o);
    return pt(o) ? v : Dt(v, y(o));
  }
  function Be(o) {
    return o == null ? o === void 0 ? U : w : he && he in Object(o) ? Ce(o) : Er(o);
  }
  function Tr(o) {
    return Oe(o) && Be(o) == u;
  }
  function Ar(o, c, y, v, C) {
    return o === c ? !0 : o == null || c == null || !Oe(o) && !Oe(c) ? o !== o && c !== c : Zn(o, c, y, v, Ar, C);
  }
  function Zn(o, c, y, v, C, M) {
    var L = pt(o), D = pt(c), z = L ? d : Pe(o), j = D ? d : Pe(c);
    z = z == u ? b : z, j = j == u ? b : j;
    var Q = z == b, ie = j == b, H = z == j;
    if (H && dt(o)) {
      if (!dt(c))
        return !1;
      L = !0, Q = !1;
    }
    if (H && !Q)
      return M || (M = new ve()), L || Nr(o) ? Xt(o, c, y, v, C, M) : Xn(o, c, z, y, v, C, M);
    if (!(y & i)) {
      var q = Q && ue.call(o, "__wrapped__"), W = ie && ue.call(c, "__wrapped__");
      if (q || W) {
        var De = q ? o.value() : o, Ne = W ? c.value() : c;
        return M || (M = new ve()), C(De, Ne, y, v, M);
      }
    }
    return H ? (M || (M = new ve()), $n(o, c, y, v, C, M)) : !1;
  }
  function zn(o) {
    if (!Cr(o) || Jn(o))
      return !1;
    var c = _r(o) ? gn : pe;
    return c.test(te(o));
  }
  function Hn(o) {
    return Oe(o) && kt(o.length) && !!F[Be(o)];
  }
  function Bn(o) {
    if (!Yn(o))
      return ze(o);
    var c = [];
    for (var y in Object(o))
      ue.call(o, y) && y != "constructor" && c.push(y);
    return c;
  }
  function Xt(o, c, y, v, C, M) {
    var L = y & i, D = o.length, z = c.length;
    if (D != z && !(L && z > D))
      return !1;
    var j = M.get(o);
    if (j && M.get(c))
      return j == c;
    var Q = -1, ie = !0, H = y & a ? new ut() : void 0;
    for (M.set(o, c), M.set(c, o); ++Q < D; ) {
      var q = o[Q], W = c[Q];
      if (v)
        var De = L ? v(W, q, Q, c, o, M) : v(q, W, Q, o, c, M);
      if (De !== void 0) {
        if (De)
          continue;
        ie = !1;
        break;
      }
      if (H) {
        if (!yr(c, function(Ne, $e) {
          if (!nt(H, $e) && (q === Ne || C(q, Ne, y, v, M)))
            return H.push($e);
        })) {
          ie = !1;
          break;
        }
      } else if (!(q === W || C(q, W, y, v, M))) {
        ie = !1;
        break;
      }
    }
    return M.delete(o), M.delete(c), ie;
  }
  function Xn(o, c, y, v, C, M, L) {
    switch (y) {
      case ne:
        if (o.byteLength != c.byteLength || o.byteOffset != c.byteOffset)
          return !1;
        o = o.buffer, c = c.buffer;
      case we:
        return !(o.byteLength != c.byteLength || !M(new Sr(o), new Sr(c)));
      case m:
      case P:
      case x:
        return xr(+o, +c);
      case T:
        return o.name == c.name && o.message == c.message;
      case g:
      case _:
        return o == c + "";
      case E:
        var D = mr;
      case h:
        var z = v & i;
        if (D || (D = Se), o.size != c.size && !z)
          return !1;
        var j = L.get(o);
        if (j)
          return j == c;
        v |= a, L.set(o, c);
        var Q = Xt(D(o), D(c), v, C, M, L);
        return L.delete(o), Q;
      case K:
        if (zt)
          return zt.call(o) == zt.call(c);
    }
    return !1;
  }
  function $n(o, c, y, v, C, M) {
    var L = y & i, D = Xe(o), z = D.length, j = Xe(c), Q = j.length;
    if (z != Q && !L)
      return !1;
    for (var ie = z; ie--; ) {
      var H = D[ie];
      if (!(L ? H in c : ue.call(c, H)))
        return !1;
    }
    var q = M.get(o);
    if (q && M.get(c))
      return q == c;
    var W = !0;
    M.set(o, c), M.set(c, o);
    for (var De = L; ++ie < z; ) {
      H = D[ie];
      var Ne = o[H], $e = c[H];
      if (v)
        var ei = L ? v($e, Ne, H, c, o, M) : v(Ne, $e, H, o, c, M);
      if (!(ei === void 0 ? Ne === $e || C(Ne, $e, y, v, M) : ei)) {
        W = !1;
        break;
      }
      De || (De = H == "constructor");
    }
    if (W && !De) {
      var Ir = o.constructor, Dr = c.constructor;
      Ir != Dr && "constructor" in o && "constructor" in c && !(typeof Ir == "function" && Ir instanceof Ir && typeof Dr == "function" && Dr instanceof Dr) && (W = !1);
    }
    return M.delete(o), M.delete(c), W;
  }
  function Xe(o) {
    return Bt(o, Wt, kn);
  }
  function ye(o, c) {
    var y = o.__data__;
    return Vn(c) ? y[typeof c == "string" ? "string" : "hash"] : y.map;
  }
  function _e(o, c) {
    var y = Rt(o, c);
    return zn(y) ? y : void 0;
  }
  function Ce(o) {
    var c = ue.call(o, he), y = o[he];
    try {
      o[he] = void 0;
      var v = !0;
    } catch {
    }
    var C = wr.call(o);
    return v && (c ? o[he] = y : delete o[he]), C;
  }
  var kn = ct ? function(o) {
    return o == null ? [] : (o = Object(o), hr(ct(o), function(c) {
      return st.call(o, c);
    }));
  } : qn, Pe = Be;
  (Ft && Pe(new Ft(new ArrayBuffer(1))) != ne || He && Pe(new He()) != E || Ut && Pe(Ut.resolve()) != l || Gt && Pe(new Gt()) != h || Zt && Pe(new Zt()) != X) && (Pe = function(o) {
    var c = Be(o), y = c == b ? o.constructor : void 0, v = y ? te(y) : "";
    if (v)
      switch (v) {
        case vr:
          return ne;
        case Me:
          return E;
        case bn:
          return l;
        case wn:
          return h;
        case Sn:
          return X;
      }
    return c;
  });
  function Wn(o, c) {
    return c = c ?? s, !!c && (typeof o == "number" || ur.test(o)) && o > -1 && o % 1 == 0 && o < c;
  }
  function Vn(o) {
    var c = typeof o;
    return c == "string" || c == "number" || c == "symbol" || c == "boolean" ? o !== "__proto__" : o === null;
  }
  function Jn(o) {
    return !!br && br in o;
  }
  function Yn(o) {
    var c = o && o.constructor, y = typeof c == "function" && c.prototype || Ge;
    return o === y;
  }
  function Er(o) {
    return wr.call(o);
  }
  function te(o) {
    if (o != null) {
      try {
        return Lt.call(o);
      } catch {
      }
      try {
        return o + "";
      } catch {
      }
    }
    return "";
  }
  function xr(o, c) {
    return o === c || o !== o && c !== c;
  }
  var Mr = Tr(/* @__PURE__ */ function() {
    return arguments;
  }()) ? Tr : function(o) {
    return Oe(o) && ue.call(o, "callee") && !st.call(o, "callee");
  }, pt = Array.isArray;
  function $t(o) {
    return o != null && kt(o.length) && !_r(o);
  }
  var dt = Kt || eo;
  function Qn(o, c) {
    return Ar(o, c);
  }
  function _r(o) {
    if (!Cr(o))
      return !1;
    var c = Be(o);
    return c == A || c == O || c == p || c == f;
  }
  function kt(o) {
    return typeof o == "number" && o > -1 && o % 1 == 0 && o <= s;
  }
  function Cr(o) {
    var c = typeof o;
    return o != null && (c == "object" || c == "function");
  }
  function Oe(o) {
    return o != null && typeof o == "object";
  }
  var Nr = It ? yn(It) : Hn;
  function Wt(o) {
    return $t(o) ? Gn(o) : Bn(o);
  }
  function qn() {
    return [];
  }
  function eo() {
    return !1;
  }
  t.exports = Qn;
})(kr, kr.exports);
var fs = kr.exports;
const Nd = /* @__PURE__ */ Ot(fs);
var ps = "Expected a function", qi = "__lodash_hash_undefined__", ea = 1 / 0, ds = 9007199254740991, hs = "[object Function]", ys = "[object GeneratorFunction]", ms = "[object Symbol]", gs = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, bs = /^\w*$/, ws = /^\./, Ss = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, vs = /[\\^$.*+?()[\]{}|]/g, Ps = /\\(\\)?/g, Os = /^\[object .+?Constructor\]$/, Ts = /^(?:0|[1-9]\d*)$/, As = typeof V == "object" && V && V.Object === Object && V, Es = typeof self == "object" && self && self.Object === Object && self, Fo = As || Es || Function("return this")();
function xs(t, e) {
  return t == null ? void 0 : t[e];
}
function Ms(t) {
  var e = !1;
  if (t != null && typeof t.toString != "function")
    try {
      e = !!(t + "");
    } catch {
    }
  return e;
}
var _s = Array.prototype, Cs = Function.prototype, ta = Object.prototype, to = Fo["__core-js_shared__"], ti = function() {
  var t = /[^.]+$/.exec(to && to.keys && to.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}(), ra = Cs.toString, rn = ta.hasOwnProperty, na = ta.toString, Ns = RegExp(
  "^" + ra.call(rn).replace(vs, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
), ri = Fo.Symbol, Is = _s.splice, Ds = oa(Fo, "Map"), nr = oa(Object, "create"), ni = ri ? ri.prototype : void 0, oi = ni ? ni.toString : void 0;
function Qe(t) {
  var e = -1, r = t ? t.length : 0;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
function Rs() {
  this.__data__ = nr ? nr(null) : {};
}
function Ls(t) {
  return this.has(t) && delete this.__data__[t];
}
function js(t) {
  var e = this.__data__;
  if (nr) {
    var r = e[t];
    return r === qi ? void 0 : r;
  }
  return rn.call(e, t) ? e[t] : void 0;
}
function Ks(t) {
  var e = this.__data__;
  return nr ? e[t] !== void 0 : rn.call(e, t);
}
function Fs(t, e) {
  var r = this.__data__;
  return r[t] = nr && e === void 0 ? qi : e, this;
}
Qe.prototype.clear = Rs;
Qe.prototype.delete = Ls;
Qe.prototype.get = js;
Qe.prototype.has = Ks;
Qe.prototype.set = Fs;
function Tt(t) {
  var e = -1, r = t ? t.length : 0;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
function Us() {
  this.__data__ = [];
}
function Gs(t) {
  var e = this.__data__, r = nn(e, t);
  if (r < 0)
    return !1;
  var n = e.length - 1;
  return r == n ? e.pop() : Is.call(e, r, 1), !0;
}
function Zs(t) {
  var e = this.__data__, r = nn(e, t);
  return r < 0 ? void 0 : e[r][1];
}
function zs(t) {
  return nn(this.__data__, t) > -1;
}
function Hs(t, e) {
  var r = this.__data__, n = nn(r, t);
  return n < 0 ? r.push([t, e]) : r[n][1] = e, this;
}
Tt.prototype.clear = Us;
Tt.prototype.delete = Gs;
Tt.prototype.get = Zs;
Tt.prototype.has = zs;
Tt.prototype.set = Hs;
function et(t) {
  var e = -1, r = t ? t.length : 0;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
function Bs() {
  this.__data__ = {
    hash: new Qe(),
    map: new (Ds || Tt)(),
    string: new Qe()
  };
}
function Xs(t) {
  return on(this, t).delete(t);
}
function $s(t) {
  return on(this, t).get(t);
}
function ks(t) {
  return on(this, t).has(t);
}
function Ws(t, e) {
  return on(this, t).set(t, e), this;
}
et.prototype.clear = Bs;
et.prototype.delete = Xs;
et.prototype.get = $s;
et.prototype.has = ks;
et.prototype.set = Ws;
function Vs(t, e, r) {
  var n = t[e];
  (!(rn.call(t, e) && ia(n, r)) || r === void 0 && !(e in t)) && (t[e] = r);
}
function nn(t, e) {
  for (var r = t.length; r--; )
    if (ia(t[r][0], e))
      return r;
  return -1;
}
function Js(t) {
  if (!Wr(t) || nc(t))
    return !1;
  var e = sc(t) || Ms(t) ? Ns : Os;
  return e.test(ac(t));
}
function Ys(t, e, r, n) {
  if (!Wr(t))
    return t;
  e = tc(e, t) ? [e] : qs(e);
  for (var i = -1, a = e.length, s = a - 1, u = t; u != null && ++i < a; ) {
    var d = ic(e[i]), p = r;
    if (i != s) {
      var m = u[d];
      p = void 0, p === void 0 && (p = Wr(m) ? m : ec(e[i + 1]) ? [] : {});
    }
    Vs(u, d, p), u = u[d];
  }
  return t;
}
function Qs(t) {
  if (typeof t == "string")
    return t;
  if (Go(t))
    return oi ? oi.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -ea ? "-0" : e;
}
function qs(t) {
  return aa(t) ? t : oc(t);
}
function on(t, e) {
  var r = t.__data__;
  return rc(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
function oa(t, e) {
  var r = xs(t, e);
  return Js(r) ? r : void 0;
}
function ec(t, e) {
  return e = e ?? ds, !!e && (typeof t == "number" || Ts.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
function tc(t, e) {
  if (aa(t))
    return !1;
  var r = typeof t;
  return r == "number" || r == "symbol" || r == "boolean" || t == null || Go(t) ? !0 : bs.test(t) || !gs.test(t) || e != null && t in Object(e);
}
function rc(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function nc(t) {
  return !!ti && ti in t;
}
var oc = Uo(function(t) {
  t = uc(t);
  var e = [];
  return ws.test(t) && e.push(""), t.replace(Ss, function(r, n, i, a) {
    e.push(i ? a.replace(Ps, "$1") : n || r);
  }), e;
});
function ic(t) {
  if (typeof t == "string" || Go(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -ea ? "-0" : e;
}
function ac(t) {
  if (t != null) {
    try {
      return ra.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
function Uo(t, e) {
  if (typeof t != "function" || e && typeof e != "function")
    throw new TypeError(ps);
  var r = function() {
    var n = arguments, i = e ? e.apply(this, n) : n[0], a = r.cache;
    if (a.has(i))
      return a.get(i);
    var s = t.apply(this, n);
    return r.cache = a.set(i, s), s;
  };
  return r.cache = new (Uo.Cache || et)(), r;
}
Uo.Cache = et;
function ia(t, e) {
  return t === e || t !== t && e !== e;
}
var aa = Array.isArray;
function sc(t) {
  var e = Wr(t) ? na.call(t) : "";
  return e == hs || e == ys;
}
function Wr(t) {
  var e = typeof t;
  return !!t && (e == "object" || e == "function");
}
function cc(t) {
  return !!t && typeof t == "object";
}
function Go(t) {
  return typeof t == "symbol" || cc(t) && na.call(t) == ms;
}
function uc(t) {
  return t == null ? "" : Qs(t);
}
function lc(t, e, r) {
  return t == null ? t : Ys(t, e, r);
}
var fc = lc;
const ro = /* @__PURE__ */ Ot(fc);
var sa = "Expected a function", ii = NaN, pc = "[object Symbol]", dc = /^\s+|\s+$/g, hc = /^[-+]0x[0-9a-f]+$/i, yc = /^0b[01]+$/i, mc = /^0o[0-7]+$/i, gc = parseInt, bc = typeof V == "object" && V && V.Object === Object && V, wc = typeof self == "object" && self && self.Object === Object && self, Sc = bc || wc || Function("return this")(), vc = Object.prototype, Pc = vc.toString, Oc = Math.max, Tc = Math.min, no = function() {
  return Sc.Date.now();
};
function Ac(t, e, r) {
  var n, i, a, s, u, d, p = 0, m = !1, P = !1, T = !0;
  if (typeof t != "function")
    throw new TypeError(sa);
  e = ai(e) || 0, Vr(r) && (m = !!r.leading, P = "maxWait" in r, a = P ? Oc(ai(r.maxWait) || 0, e) : a, T = "trailing" in r ? !!r.trailing : T);
  function A(h) {
    var _ = n, K = i;
    return n = i = void 0, p = h, s = t.apply(K, _), s;
  }
  function O(h) {
    return p = h, u = setTimeout(w, e), m ? A(h) : s;
  }
  function E(h) {
    var _ = h - d, K = h - p, U = e - _;
    return P ? Tc(U, a - K) : U;
  }
  function x(h) {
    var _ = h - d, K = h - p;
    return d === void 0 || _ >= e || _ < 0 || P && K >= a;
  }
  function w() {
    var h = no();
    if (x(h))
      return b(h);
    u = setTimeout(w, E(h));
  }
  function b(h) {
    return u = void 0, T && n ? A(h) : (n = i = void 0, s);
  }
  function l() {
    u !== void 0 && clearTimeout(u), p = 0, n = d = i = u = void 0;
  }
  function f() {
    return u === void 0 ? s : b(no());
  }
  function g() {
    var h = no(), _ = x(h);
    if (n = arguments, i = this, d = h, _) {
      if (u === void 0)
        return O(d);
      if (P)
        return u = setTimeout(w, e), A(d);
    }
    return u === void 0 && (u = setTimeout(w, e)), s;
  }
  return g.cancel = l, g.flush = f, g;
}
function Ec(t, e, r) {
  var n = !0, i = !0;
  if (typeof t != "function")
    throw new TypeError(sa);
  return Vr(r) && (n = "leading" in r ? !!r.leading : n, i = "trailing" in r ? !!r.trailing : i), Ac(t, e, {
    leading: n,
    maxWait: e,
    trailing: i
  });
}
function Vr(t) {
  var e = typeof t;
  return !!t && (e == "object" || e == "function");
}
function xc(t) {
  return !!t && typeof t == "object";
}
function Mc(t) {
  return typeof t == "symbol" || xc(t) && Pc.call(t) == pc;
}
function ai(t) {
  if (typeof t == "number")
    return t;
  if (Mc(t))
    return ii;
  if (Vr(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = Vr(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = t.replace(dc, "");
  var r = yc.test(t);
  return r || mc.test(t) ? gc(t.slice(2), r ? 2 : 8) : hc.test(t) ? ii : +t;
}
var _c = Ec;
const Id = /* @__PURE__ */ Ot(_c);
function Cc(t, e) {
  return window.getComputedStyle(t, null).getPropertyValue(e);
}
function Dd(t) {
  const e = Cc(t, "line-height");
  if (e === "normal") {
    console.error("请明确设置 行高 line-height");
    return;
  }
  return parseInt(e, 10);
}
function Rd(t) {
  return t ? t.getBoundingClientRect().height : 0;
}
function Ld(t) {
  return t ? t.getBoundingClientRect().width : 0;
}
function jd(t) {
  return t.getBoundingClientRect();
}
function Kd(t, e, r, n = !1) {
  t && e && r && t.addEventListener(e, r, n);
}
function Fd(t, e, r) {
  t && e && r && t.removeEventListener(e, r, !1);
}
function Nc(t) {
  return new Promise((e, r) => {
    if (typeof t != "string" || !t.length)
      return r();
    if (Array.from(document.scripts).some((i) => i.src === t))
      return e();
    const n = document.createElement("script");
    n.setAttribute("src", t), n.setAttribute("data-namespace", t), n.onload = () => {
      e();
    }, n.onerror = () => {
      r();
    }, document.body.appendChild(n);
  });
}
function Ud(t) {
  if (typeof document < "u" && typeof window < "u" && typeof document.createElement == "function")
    return Nc(t);
}
function Gd(t, e) {
  return new Promise((r, n) => {
    let i = new IntersectionObserver(([{ isIntersecting: a }]) => {
      r(a), i == null || i.unobserve(t), i = null;
    }, e);
    i.observe(t);
  });
}
function ge(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function ca(t) {
  return ge(t) === "Null";
}
function ua(t) {
  return ge(t) === "Undefined";
}
function So(t) {
  return ua(t) || ca(t);
}
function Ic(t) {
  return ge(t) === "String";
}
function Dc(t) {
  return ge(t) === "Number";
}
function Rc(t) {
  return ge(t) === "Function";
}
const Zo = Array.isArray;
function Lc(t) {
  return ge(t) == "Object";
}
function la(t) {
  return !!t && typeof t == "object";
}
function jc(t) {
  return ge(t) === "Map";
}
function Kc(t) {
  return ge(t) === "Set";
}
function Fc(t) {
  return ge(t) === "Symbol";
}
function Uc(t) {
  return ge(t) === "Promise";
}
function Gc(t) {
  return /^https?:\/\//.test(t);
}
function tt() {
  return typeof window < "u" && typeof document < "u";
}
const Zc = tt() && typeof document.body.style.webkitLineClamp < "u", zc = tt() && typeof ResizeObserver < "u", Hc = tt() && typeof IntersectionObserver < "u", Bc = tt() && /^((?!chrome|android).)*safari/i.test(navigator.userAgent), Xc = tt() && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), Zd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getType: ge,
  intersectionObserverEnabled: Hc,
  isArray: Zo,
  isBrowser: tt,
  isFunction: Rc,
  isMap: jc,
  isMobile: Xc,
  isNull: ca,
  isNullOrUndef: So,
  isNumber: Dc,
  isObject: Lc,
  isObjectType: la,
  isPromise: Uc,
  isSafari: Bc,
  isSet: Kc,
  isString: Ic,
  isSymbol: Fc,
  isUndef: ua,
  isUrl: Gc,
  nativeEllipsisEnabled: Zc,
  resizeObserverEnabled: zc
}, Symbol.toStringTag, { value: "Module" }));
class $c {
  constructor(e = "MOGIC_") {
    re(this, "storage");
    re(this, "prefix");
    typeof window < "u" && (this.storage = window.localStorage, this.prefix = e);
  }
  getKey(e) {
    return `${this.prefix}${e}`.toUpperCase();
  }
  get(e) {
    var n;
    const r = (n = this.storage) == null ? void 0 : n.getItem(this.getKey(e));
    if (!r) return null;
    try {
      const i = JSON.parse(r), { value: a, expire: s } = i;
      if (So(s) || s >= (/* @__PURE__ */ new Date()).getTime())
        return a;
      this.remove(e);
    } catch (i) {
      console.error(i);
    }
    return null;
  }
  /**
   * @param {string} key
   * @param {*} value
   * @param {*} expire time in ms
   */
  set(e, r, n) {
    var a;
    const i = JSON.stringify({
      value: r,
      time: Date.now(),
      expire: So(n) ? null : (/* @__PURE__ */ new Date()).getTime() + (n || 0)
    });
    try {
      (a = this.storage) == null || a.setItem(this.getKey(e), i);
    } catch (s) {
      console.error(s);
    }
  }
  remove(e) {
    var r;
    (r = this.storage) == null || r.removeItem(this.getKey(e));
  }
  clear(e) {
    var n, i;
    const r = {};
    e != null && e.length && e.forEach((a) => {
      this.get(a) && (r[a] = this.get(a));
    }), (n = this.storage) == null || n.clear(), (i = Object.keys(r)) == null || i.forEach((a) => {
      this.set(a, r[a]);
    });
  }
}
const zd = new $c();
function Hd(t) {
  return (...e) => {
    if (typeof t == "function") {
      const r = t(...e);
      return r instanceof Promise ? r : new Promise((n, i) => {
        try {
          n(r);
        } catch (a) {
          i(a);
        }
      });
    }
    return Promise.resolve(t);
  };
}
const fa = Symbol("cancel"), Bd = (t) => () => t(pa()), pa = () => new Error("cancel", { cause: fa }), vo = (t) => Wc(t, "cause") === fa, Xd = (t) => {
  var e;
  return t.type !== "error" || !["cancel", "notReporting"].includes(((e = t.message) == null ? void 0 : e.toString()) || "");
}, $d = (t) => {
  window.addEventListener("unhandledrejection", (e) => {
    if (vo(e.reason))
      return e.preventDefault();
  }), t != null && t.config && (t.config.errorHandler = (e) => {
    if (!vo(e))
      throw e;
  });
};
function kd(t) {
  const e = Symbol();
  return Promise.race([t, e]).then((r) => r === e ? "pending" : "fulfilled").catch(() => "rejected");
}
const kc = (t) => {
  let e = () => {
  };
  const r = new Promise((n, i) => {
    t.then(n).catch(i), e = () => i(pa());
  });
  return r.cancel = e, r.catch((n) => {
    if (vo(n))
      return console.log("Promise cancelled.");
    throw n;
  }), r;
}, Wd = (t) => new Promise((e) => {
  const r = setTimeout(() => e(r), t);
});
class Vd {
  constructor() {
    re(this, "cancelMap", /* @__PURE__ */ new Map());
  }
  add(e, r) {
    const n = kc(e);
    return r = r ?? Symbol("key"), this.cancelMap.set(r, n.cancel), n;
  }
  cancel(e) {
    const r = this.cancelMap.get(e);
    r && (r(), this.cancelMap.delete(e));
  }
  cancelAll() {
    this.cancelMap.forEach((e) => e()), this.cancelMap.clear();
  }
}
function Jd(t) {
  return new Promise((e, r) => {
    const n = new Image();
    n.onload = () => {
      e({
        width: n.width,
        height: n.height,
        naturalWidth: n.naturalWidth,
        naturalHeight: n.naturalHeight
      });
    }, n.onerror = r, n.src = t;
  });
}
function Wc(t, e) {
  Zo(e) || (e = [e]);
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    return la(t) && n in t ? t[n] : void 0;
  }
}
function Yd(t, e = window.location.href) {
  const r = e.split("?")[1];
  return r ? new URLSearchParams(r).get(t) : void 0;
}
function Qd(t, e, r = window.location.href) {
  const n = r.split("?")[1];
  if (!n) return r + `?${t}=${e}`;
  const i = new URLSearchParams(n);
  return i.set(t, e), r.replace(n, i.toString());
}
function Rr(t, e) {
  return t.toString().padStart(e, "0");
}
function qd(t, e) {
  if (!t)
    return "00:00.00";
  const { withMS: r = !0, withHour: n = !1 } = e ?? {}, i = Math.floor(t / 3600), a = Math.floor(n ? t % 3600 / 60 : t / 60), s = Math.floor(t % 60), u = Math.floor(t % 1 * 100);
  let d = `${Rr(a, 2)}:${Rr(s, 2)}`;
  return n && i > 0 && (d = `${Rr(i, 2)}:${d}`), r ? `${d}.${Rr(u, 2)}` : d;
}
function eh(t, e, r) {
  if (e = e || "yyyy-MM-dd hh:mm:ss", !t)
    return r || "";
  const n = new Date(Number.isNaN(+t) ? t : +t), i = {
    "M+": n.getMonth() + 1,
    "d+": n.getDate(),
    "h+": n.getHours(),
    "m+": n.getMinutes(),
    "s+": n.getSeconds(),
    "q+": Math.floor((n.getMonth() + 3) / 3),
    S: n.getMilliseconds()
  };
  /(y+)/.test(e) && (e = e.replace(RegExp.$1, `${n.getFullYear()}`.substr(4 - RegExp.$1.length)));
  let a;
  for (a in i)
    if (new RegExp(`(${a})`).test(e)) {
      const s = RegExp.$1.length === 1 ? String(i[a]) : `00${i[a]}`.substr(`${i[a]}`.length);
      e = e.replace(RegExp.$1, s);
    }
  return e;
}
const Lr = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
function th(t) {
  if (t >= 100 || t < 0)
    throw new Error("数字必须在0-100之间");
  if (t = Number(t.toFixed()), t < 10)
    return Lr[t];
  {
    const e = String(t).split("").map((r) => Number(r));
    return (e[0] === 1 ? "" : Lr[e[0]]) + Lr[10] + (e[1] ? Lr[e[1]] : "");
  }
}
function rh(t, e = 2) {
  if (/^\d+$/.test(`${t}`)) {
    if (t = +t, t === 0)
      return "0";
    const r = parseInt(`${Math.floor(Math.log(t) / Math.log(1024))}`);
    let n = (t / 1024 ** r).toFixed(e);
    return +n % 1 === 0 ? n = `${Number(n)}` : n[n.length - 1] === "0" && (n = n.slice(0, -1)), n + ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][r];
  } else
    return t;
}
const nh = (t, e, r, n, i) => (t - e) / (r - e) * (i - n) + n, ke = (t, e, r = 0) => t.toString().padStart(e, `${r}`).slice(0, e), Vc = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|S{1,3}/g, oh = (t, e = "mm:ss.SS", { ignoreMSZero: r = !1 } = {}) => {
  const n = ke(t % 1e3, 3);
  t = Math.floor(t / 1e3);
  const i = t % 60;
  t = Math.floor(t / 60);
  const a = t % 60, s = Math.floor(t / 60), u = {
    h: s,
    hh: ke(s, 2),
    m: a,
    mm: ke(a, 2),
    s: i,
    ss: ke(i, 2),
    S: ke(n, 1),
    SS: ke(n, 2),
    SSS: ke(n, 3)
  };
  return e.replace(Vc, (d, p) => {
    if (p)
      return p;
    if (d.includes("S") && r) {
      if (+u[d] % 100 === 0 && +u[d] / 100 !== 0)
        return +u[d] / 100;
      if (+u[d] % 10 === 0 && +u[d] / 10 !== 0)
        return +u[d] / 10;
    }
    return u[d];
  });
}, ih = (t) => {
  var r;
  const e = ((r = (t || "").match(/\d+/g)) == null ? void 0 : r.map(Number)) || [0, 0, 0];
  for (; e.length < 3; )
    e.push(0);
  return e;
}, ah = (t) => t < 0 ? 0 : t, sh = (t, e = 25) => Math.max(0, Math.round(t * e)), ch = (t, e = 25, r = 1) => Math.floor(t / e * 10 ** r) / 10 ** r;
function uh(t, e) {
  const { local: r = "zh-CN" } = e ?? {}, n = Number(t || 0);
  return isNaN(n) ? `${t}` : r !== "zh-CN" ? n < 1e3 ? `${n}` : n < 1e3 * 1e3 ? Math.floor(n / 100) / 10 + "k" : Math.floor(n / (100 * 1e3)) / 10 + "M" : n < 1e4 ? `${n}` : n < 1e4 * 1e4 ? Math.floor(n / 1e3) / 10 + "万" : Math.floor(n / (1e3 * 1e4)) / 10 + "亿";
}
const lh = (t) => t.filter((e) => !!e), fh = (t) => {
  if (Array.isArray(t))
    return t;
  try {
    return JSON.parse(t);
  } catch {
    return [t];
  }
}, Jc = (t) => {
  try {
    return JSON.parse(t);
  } catch {
    return t;
  }
}, ph = (t, e) => {
  const r = /* @__PURE__ */ new Map();
  return t.forEach((n) => r.set(e(n), n)), Array.from(r.values());
}, dh = (t, e) => t ? [...t, e] : [e], hh = (t, e, r) => {
  Array.isArray(t[e]) || (t[e] = []), t[e].push(r);
}, si = /* @__PURE__ */ new Map();
function yh(t) {
  const e = si.get(t);
  if (e)
    return e;
  const r = fetch(t + "?t=" + Date.now()).then((n) => n.json()).then(
    (n) => n.config.reduce((i, a) => (i[a.id] = a.control === "json" ? Jc(a.content) : a.content, i), {})
  );
  return si.set(t, r), r;
}
function mh(t) {
  Array.from(document.querySelectorAll("video")).forEach((e) => e !== t && e.pause());
}
const gh = (t) => {
  const e = t.name.lastIndexOf("."), r = t.name.substring(0, e), n = t.name.substring(e + 1), i = t.type.split("/")[0];
  return {
    name: r,
    uploadFileSubType: n,
    mediaType: i.charAt(0).toUpperCase() + i.slice(1)
  };
};
function bh(t) {
  const e = (r) => new Promise((n, i) => {
    const a = document.createElement("textarea");
    a.value = r, a.style.top = "-200", a.style.left = "0", a.style.position = "fixed", a.style.opacity = "0", document.body.appendChild(a), a.select();
    try {
      if (document.execCommand("copy"))
        n();
      else {
        const u = new Error("复制失败");
        throw i(u), u;
      }
    } catch {
      const u = new Error("复制失败");
      throw i(u), u;
    }
  });
  return !navigator.clipboard || !window.isSecureContext ? e(t) : navigator.clipboard.writeText(t).catch(() => e(t));
}
const wh = (t) => {
  window.open(t, "_blank");
}, Sh = (t) => t, vh = (t, e) => e.includes(t), Ph = (t) => Object.keys(t), Oh = (t) => Object.entries(t);
function Th(t) {
  const e = {};
  return Object.entries(t).forEach(([r, n]) => {
    if (!n || typeof n != "object") return;
    let i = r.replace(/^\.\//, "");
    const a = i.lastIndexOf(".");
    i = i.substring(0, a);
    const s = i.split("/"), u = s.shift(), d = s.join(".");
    u && (d ? (ro(e, u, e[u] || {}), ro(e[u], d, n)) : ro(e, u, n || {}));
  }), e;
}
const Ah = (t, e) => {
  Object.keys(e).forEach((r) => {
    t.global.mergeLocaleMessage(r, e[r]);
  });
};
function Eh(t) {
  if (t)
    return Array.isArray(t) ? t[0] || void 0 : t;
}
function xh(t, e) {
  Object.keys(t).forEach((r) => t[r] = e[r]);
}
function Mh(t, e) {
  t.component && (t.component.props || (t.component.props = {}), Object.assign(t.component.props, e));
}
function da(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: Yc } = Object.prototype, { getPrototypeOf: zo } = Object, an = /* @__PURE__ */ ((t) => (e) => {
  const r = Yc.call(e);
  return t[r] || (t[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), be = (t) => (t = t.toLowerCase(), (e) => an(e) === t), sn = (t) => (e) => typeof e === t, { isArray: At } = Array, or = sn("undefined");
function Qc(t) {
  return t !== null && !or(t) && t.constructor !== null && !or(t.constructor) && fe(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const ha = be("ArrayBuffer");
function qc(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && ha(t.buffer), e;
}
const eu = sn("string"), fe = sn("function"), ya = sn("number"), cn = (t) => t !== null && typeof t == "object", tu = (t) => t === !0 || t === !1, zr = (t) => {
  if (an(t) !== "object")
    return !1;
  const e = zo(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, ru = be("Date"), nu = be("File"), ou = be("Blob"), iu = be("FileList"), au = (t) => cn(t) && fe(t.pipe), su = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || fe(t.append) && ((e = an(t)) === "formdata" || // detect form-data instance
  e === "object" && fe(t.toString) && t.toString() === "[object FormData]"));
}, cu = be("URLSearchParams"), [uu, lu, fu, pu] = ["ReadableStream", "Request", "Response", "Headers"].map(be), du = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ir(t, e, { allOwnKeys: r = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let n, i;
  if (typeof t != "object" && (t = [t]), At(t))
    for (n = 0, i = t.length; n < i; n++)
      e.call(null, t[n], n, t);
  else {
    const a = r ? Object.getOwnPropertyNames(t) : Object.keys(t), s = a.length;
    let u;
    for (n = 0; n < s; n++)
      u = a[n], e.call(null, t[u], u, t);
  }
}
function ma(t, e) {
  e = e.toLowerCase();
  const r = Object.keys(t);
  let n = r.length, i;
  for (; n-- > 0; )
    if (i = r[n], e === i.toLowerCase())
      return i;
  return null;
}
const ga = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, ba = (t) => !or(t) && t !== ga;
function Po() {
  const { caseless: t } = ba(this) && this || {}, e = {}, r = (n, i) => {
    const a = t && ma(e, i) || i;
    zr(e[a]) && zr(n) ? e[a] = Po(e[a], n) : zr(n) ? e[a] = Po({}, n) : At(n) ? e[a] = n.slice() : e[a] = n;
  };
  for (let n = 0, i = arguments.length; n < i; n++)
    arguments[n] && ir(arguments[n], r);
  return e;
}
const hu = (t, e, r, { allOwnKeys: n } = {}) => (ir(e, (i, a) => {
  r && fe(i) ? t[a] = da(i, r) : t[a] = i;
}, { allOwnKeys: n }), t), yu = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), mu = (t, e, r, n) => {
  t.prototype = Object.create(e.prototype, n), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), r && Object.assign(t.prototype, r);
}, gu = (t, e, r, n) => {
  let i, a, s;
  const u = {};
  if (e = e || {}, t == null) return e;
  do {
    for (i = Object.getOwnPropertyNames(t), a = i.length; a-- > 0; )
      s = i[a], (!n || n(s, t, e)) && !u[s] && (e[s] = t[s], u[s] = !0);
    t = r !== !1 && zo(t);
  } while (t && (!r || r(t, e)) && t !== Object.prototype);
  return e;
}, bu = (t, e, r) => {
  t = String(t), (r === void 0 || r > t.length) && (r = t.length), r -= e.length;
  const n = t.indexOf(e, r);
  return n !== -1 && n === r;
}, wu = (t) => {
  if (!t) return null;
  if (At(t)) return t;
  let e = t.length;
  if (!ya(e)) return null;
  const r = new Array(e);
  for (; e-- > 0; )
    r[e] = t[e];
  return r;
}, Su = /* @__PURE__ */ ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && zo(Uint8Array)), vu = (t, e) => {
  const n = (t && t[Symbol.iterator]).call(t);
  let i;
  for (; (i = n.next()) && !i.done; ) {
    const a = i.value;
    e.call(t, a[0], a[1]);
  }
}, Pu = (t, e) => {
  let r;
  const n = [];
  for (; (r = t.exec(e)) !== null; )
    n.push(r);
  return n;
}, Ou = be("HTMLFormElement"), Tu = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, i) {
    return n.toUpperCase() + i;
  }
), ci = (({ hasOwnProperty: t }) => (e, r) => t.call(e, r))(Object.prototype), Au = be("RegExp"), wa = (t, e) => {
  const r = Object.getOwnPropertyDescriptors(t), n = {};
  ir(r, (i, a) => {
    let s;
    (s = e(i, a, t)) !== !1 && (n[a] = s || i);
  }), Object.defineProperties(t, n);
}, Eu = (t) => {
  wa(t, (e, r) => {
    if (fe(t) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = t[r];
    if (fe(n)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, xu = (t, e) => {
  const r = {}, n = (i) => {
    i.forEach((a) => {
      r[a] = !0;
    });
  };
  return At(t) ? n(t) : n(String(t).split(e)), r;
}, Mu = () => {
}, _u = (t, e) => t != null && Number.isFinite(t = +t) ? t : e, oo = "abcdefghijklmnopqrstuvwxyz", ui = "0123456789", Sa = {
  DIGIT: ui,
  ALPHA: oo,
  ALPHA_DIGIT: oo + oo.toUpperCase() + ui
}, Cu = (t = 16, e = Sa.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = e;
  for (; t--; )
    r += e[Math.random() * n | 0];
  return r;
};
function Nu(t) {
  return !!(t && fe(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
const Iu = (t) => {
  const e = new Array(10), r = (n, i) => {
    if (cn(n)) {
      if (e.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        e[i] = n;
        const a = At(n) ? [] : {};
        return ir(n, (s, u) => {
          const d = r(s, i + 1);
          !or(d) && (a[u] = d);
        }), e[i] = void 0, a;
      }
    }
    return n;
  };
  return r(t, 0);
}, Du = be("AsyncFunction"), Ru = (t) => t && (cn(t) || fe(t)) && fe(t.then) && fe(t.catch), S = {
  isArray: At,
  isArrayBuffer: ha,
  isBuffer: Qc,
  isFormData: su,
  isArrayBufferView: qc,
  isString: eu,
  isNumber: ya,
  isBoolean: tu,
  isObject: cn,
  isPlainObject: zr,
  isReadableStream: uu,
  isRequest: lu,
  isResponse: fu,
  isHeaders: pu,
  isUndefined: or,
  isDate: ru,
  isFile: nu,
  isBlob: ou,
  isRegExp: Au,
  isFunction: fe,
  isStream: au,
  isURLSearchParams: cu,
  isTypedArray: Su,
  isFileList: iu,
  forEach: ir,
  merge: Po,
  extend: hu,
  trim: du,
  stripBOM: yu,
  inherits: mu,
  toFlatObject: gu,
  kindOf: an,
  kindOfTest: be,
  endsWith: bu,
  toArray: wu,
  forEachEntry: vu,
  matchAll: Pu,
  isHTMLForm: Ou,
  hasOwnProperty: ci,
  hasOwnProp: ci,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: wa,
  freezeMethods: Eu,
  toObjectSet: xu,
  toCamelCase: Tu,
  noop: Mu,
  toFiniteNumber: _u,
  findKey: ma,
  global: ga,
  isContextDefined: ba,
  ALPHABET: Sa,
  generateString: Cu,
  isSpecCompliantForm: Nu,
  toJSONObject: Iu,
  isAsyncFn: Du,
  isThenable: Ru
};
function N(t, e, r, n, i) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), r && (this.config = r), n && (this.request = n), i && (this.response = i);
}
S.inherits(N, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: S.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const va = N.prototype, Pa = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  Pa[t] = { value: t };
});
Object.defineProperties(N, Pa);
Object.defineProperty(va, "isAxiosError", { value: !0 });
N.from = (t, e, r, n, i, a) => {
  const s = Object.create(va);
  return S.toFlatObject(t, s, function(d) {
    return d !== Error.prototype;
  }, (u) => u !== "isAxiosError"), N.call(s, t.message, e, r, n, i), s.cause = t, s.name = t.name, a && Object.assign(s, a), s;
};
const Lu = null;
function Oo(t) {
  return S.isPlainObject(t) || S.isArray(t);
}
function Oa(t) {
  return S.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function li(t, e, r) {
  return t ? t.concat(e).map(function(i, a) {
    return i = Oa(i), !r && a ? "[" + i + "]" : i;
  }).join(r ? "." : "") : e;
}
function ju(t) {
  return S.isArray(t) && !t.some(Oo);
}
const Ku = S.toFlatObject(S, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function un(t, e, r) {
  if (!S.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), r = S.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(E, x) {
    return !S.isUndefined(x[E]);
  });
  const n = r.metaTokens, i = r.visitor || m, a = r.dots, s = r.indexes, d = (r.Blob || typeof Blob < "u" && Blob) && S.isSpecCompliantForm(e);
  if (!S.isFunction(i))
    throw new TypeError("visitor must be a function");
  function p(O) {
    if (O === null) return "";
    if (S.isDate(O))
      return O.toISOString();
    if (!d && S.isBlob(O))
      throw new N("Blob is not supported. Use a Buffer instead.");
    return S.isArrayBuffer(O) || S.isTypedArray(O) ? d && typeof Blob == "function" ? new Blob([O]) : Buffer.from(O) : O;
  }
  function m(O, E, x) {
    let w = O;
    if (O && !x && typeof O == "object") {
      if (S.endsWith(E, "{}"))
        E = n ? E : E.slice(0, -2), O = JSON.stringify(O);
      else if (S.isArray(O) && ju(O) || (S.isFileList(O) || S.endsWith(E, "[]")) && (w = S.toArray(O)))
        return E = Oa(E), w.forEach(function(l, f) {
          !(S.isUndefined(l) || l === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? li([E], f, a) : s === null ? E : E + "[]",
            p(l)
          );
        }), !1;
    }
    return Oo(O) ? !0 : (e.append(li(x, E, a), p(O)), !1);
  }
  const P = [], T = Object.assign(Ku, {
    defaultVisitor: m,
    convertValue: p,
    isVisitable: Oo
  });
  function A(O, E) {
    if (!S.isUndefined(O)) {
      if (P.indexOf(O) !== -1)
        throw Error("Circular reference detected in " + E.join("."));
      P.push(O), S.forEach(O, function(w, b) {
        (!(S.isUndefined(w) || w === null) && i.call(
          e,
          w,
          S.isString(b) ? b.trim() : b,
          E,
          T
        )) === !0 && A(w, E ? E.concat(b) : [b]);
      }), P.pop();
    }
  }
  if (!S.isObject(t))
    throw new TypeError("data must be an object");
  return A(t), e;
}
function fi(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(n) {
    return e[n];
  });
}
function Ho(t, e) {
  this._pairs = [], t && un(t, this, e);
}
const Ta = Ho.prototype;
Ta.append = function(e, r) {
  this._pairs.push([e, r]);
};
Ta.toString = function(e) {
  const r = e ? function(n) {
    return e.call(this, n, fi);
  } : fi;
  return this._pairs.map(function(i) {
    return r(i[0]) + "=" + r(i[1]);
  }, "").join("&");
};
function Fu(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Aa(t, e, r) {
  if (!e)
    return t;
  const n = r && r.encode || Fu, i = r && r.serialize;
  let a;
  if (i ? a = i(e, r) : a = S.isURLSearchParams(e) ? e.toString() : new Ho(e, r).toString(n), a) {
    const s = t.indexOf("#");
    s !== -1 && (t = t.slice(0, s)), t += (t.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return t;
}
class pi {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, r, n) {
    return this.handlers.push({
      fulfilled: e,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    S.forEach(this.handlers, function(n) {
      n !== null && e(n);
    });
  }
}
const Ea = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Uu = typeof URLSearchParams < "u" ? URLSearchParams : Ho, Gu = typeof FormData < "u" ? FormData : null, Zu = typeof Blob < "u" ? Blob : null, zu = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Uu,
    FormData: Gu,
    Blob: Zu
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Bo = typeof window < "u" && typeof document < "u", Hu = ((t) => Bo && ["ReactNative", "NativeScript", "NS"].indexOf(t) < 0)(typeof navigator < "u" && navigator.product), Bu = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Xu = Bo && window.location.href || "http://localhost", $u = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Bo,
  hasStandardBrowserEnv: Hu,
  hasStandardBrowserWebWorkerEnv: Bu,
  origin: Xu
}, Symbol.toStringTag, { value: "Module" })), me = {
  ...$u,
  ...zu
};
function ku(t, e) {
  return un(t, new me.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, i, a) {
      return me.isNode && S.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function Wu(t) {
  return S.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function Vu(t) {
  const e = {}, r = Object.keys(t);
  let n;
  const i = r.length;
  let a;
  for (n = 0; n < i; n++)
    a = r[n], e[a] = t[a];
  return e;
}
function xa(t) {
  function e(r, n, i, a) {
    let s = r[a++];
    if (s === "__proto__") return !0;
    const u = Number.isFinite(+s), d = a >= r.length;
    return s = !s && S.isArray(i) ? i.length : s, d ? (S.hasOwnProp(i, s) ? i[s] = [i[s], n] : i[s] = n, !u) : ((!i[s] || !S.isObject(i[s])) && (i[s] = []), e(r, n, i[s], a) && S.isArray(i[s]) && (i[s] = Vu(i[s])), !u);
  }
  if (S.isFormData(t) && S.isFunction(t.entries)) {
    const r = {};
    return S.forEachEntry(t, (n, i) => {
      e(Wu(n), i, r, 0);
    }), r;
  }
  return null;
}
function Ju(t, e, r) {
  if (S.isString(t))
    try {
      return (e || JSON.parse)(t), S.trim(t);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(t);
}
const ar = {
  transitional: Ea,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, r) {
    const n = r.getContentType() || "", i = n.indexOf("application/json") > -1, a = S.isObject(e);
    if (a && S.isHTMLForm(e) && (e = new FormData(e)), S.isFormData(e))
      return i ? JSON.stringify(xa(e)) : e;
    if (S.isArrayBuffer(e) || S.isBuffer(e) || S.isStream(e) || S.isFile(e) || S.isBlob(e) || S.isReadableStream(e))
      return e;
    if (S.isArrayBufferView(e))
      return e.buffer;
    if (S.isURLSearchParams(e))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let u;
    if (a) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return ku(e, this.formSerializer).toString();
      if ((u = S.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
        const d = this.env && this.env.FormData;
        return un(
          u ? { "files[]": e } : e,
          d && new d(),
          this.formSerializer
        );
      }
    }
    return a || i ? (r.setContentType("application/json", !1), Ju(e)) : e;
  }],
  transformResponse: [function(e) {
    const r = this.transitional || ar.transitional, n = r && r.forcedJSONParsing, i = this.responseType === "json";
    if (S.isResponse(e) || S.isReadableStream(e))
      return e;
    if (e && S.isString(e) && (n && !this.responseType || i)) {
      const s = !(r && r.silentJSONParsing) && i;
      try {
        return JSON.parse(e);
      } catch (u) {
        if (s)
          throw u.name === "SyntaxError" ? N.from(u, N.ERR_BAD_RESPONSE, this, null, this.response) : u;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: me.classes.FormData,
    Blob: me.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
S.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  ar.headers[t] = {};
});
const Yu = S.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Qu = (t) => {
  const e = {};
  let r, n, i;
  return t && t.split(`
`).forEach(function(s) {
    i = s.indexOf(":"), r = s.substring(0, i).trim().toLowerCase(), n = s.substring(i + 1).trim(), !(!r || e[r] && Yu[r]) && (r === "set-cookie" ? e[r] ? e[r].push(n) : e[r] = [n] : e[r] = e[r] ? e[r] + ", " + n : n);
  }), e;
}, di = Symbol("internals");
function Vt(t) {
  return t && String(t).trim().toLowerCase();
}
function Hr(t) {
  return t === !1 || t == null ? t : S.isArray(t) ? t.map(Hr) : String(t);
}
function qu(t) {
  const e = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(t); )
    e[n[1]] = n[2];
  return e;
}
const el = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function io(t, e, r, n, i) {
  if (S.isFunction(n))
    return n.call(this, e, r);
  if (i && (e = r), !!S.isString(e)) {
    if (S.isString(n))
      return e.indexOf(n) !== -1;
    if (S.isRegExp(n))
      return n.test(e);
  }
}
function tl(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, r, n) => r.toUpperCase() + n);
}
function rl(t, e) {
  const r = S.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(t, n + r, {
      value: function(i, a, s) {
        return this[n].call(this, e, i, a, s);
      },
      configurable: !0
    });
  });
}
class ae {
  constructor(e) {
    e && this.set(e);
  }
  set(e, r, n) {
    const i = this;
    function a(u, d, p) {
      const m = Vt(d);
      if (!m)
        throw new Error("header name must be a non-empty string");
      const P = S.findKey(i, m);
      (!P || i[P] === void 0 || p === !0 || p === void 0 && i[P] !== !1) && (i[P || d] = Hr(u));
    }
    const s = (u, d) => S.forEach(u, (p, m) => a(p, m, d));
    if (S.isPlainObject(e) || e instanceof this.constructor)
      s(e, r);
    else if (S.isString(e) && (e = e.trim()) && !el(e))
      s(Qu(e), r);
    else if (S.isHeaders(e))
      for (const [u, d] of e.entries())
        a(d, u, n);
    else
      e != null && a(r, e, n);
    return this;
  }
  get(e, r) {
    if (e = Vt(e), e) {
      const n = S.findKey(this, e);
      if (n) {
        const i = this[n];
        if (!r)
          return i;
        if (r === !0)
          return qu(i);
        if (S.isFunction(r))
          return r.call(this, i, n);
        if (S.isRegExp(r))
          return r.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, r) {
    if (e = Vt(e), e) {
      const n = S.findKey(this, e);
      return !!(n && this[n] !== void 0 && (!r || io(this, this[n], n, r)));
    }
    return !1;
  }
  delete(e, r) {
    const n = this;
    let i = !1;
    function a(s) {
      if (s = Vt(s), s) {
        const u = S.findKey(n, s);
        u && (!r || io(n, n[u], u, r)) && (delete n[u], i = !0);
      }
    }
    return S.isArray(e) ? e.forEach(a) : a(e), i;
  }
  clear(e) {
    const r = Object.keys(this);
    let n = r.length, i = !1;
    for (; n--; ) {
      const a = r[n];
      (!e || io(this, this[a], a, e, !0)) && (delete this[a], i = !0);
    }
    return i;
  }
  normalize(e) {
    const r = this, n = {};
    return S.forEach(this, (i, a) => {
      const s = S.findKey(n, a);
      if (s) {
        r[s] = Hr(i), delete r[a];
        return;
      }
      const u = e ? tl(a) : String(a).trim();
      u !== a && delete r[a], r[u] = Hr(i), n[u] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const r = /* @__PURE__ */ Object.create(null);
    return S.forEach(this, (n, i) => {
      n != null && n !== !1 && (r[i] = e && S.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, r]) => e + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...r) {
    const n = new this(e);
    return r.forEach((i) => n.set(i)), n;
  }
  static accessor(e) {
    const n = (this[di] = this[di] = {
      accessors: {}
    }).accessors, i = this.prototype;
    function a(s) {
      const u = Vt(s);
      n[u] || (rl(i, s), n[u] = !0);
    }
    return S.isArray(e) ? e.forEach(a) : a(e), this;
  }
}
ae.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
S.reduceDescriptors(ae.prototype, ({ value: t }, e) => {
  let r = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(n) {
      this[r] = n;
    }
  };
});
S.freezeMethods(ae);
function ao(t, e) {
  const r = this || ar, n = e || r, i = ae.from(n.headers);
  let a = n.data;
  return S.forEach(t, function(u) {
    a = u.call(r, a, i.normalize(), e ? e.status : void 0);
  }), i.normalize(), a;
}
function Ma(t) {
  return !!(t && t.__CANCEL__);
}
function Et(t, e, r) {
  N.call(this, t ?? "canceled", N.ERR_CANCELED, e, r), this.name = "CanceledError";
}
S.inherits(Et, N, {
  __CANCEL__: !0
});
function _a(t, e, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? t(r) : e(new N(
    "Request failed with status code " + r.status,
    [N.ERR_BAD_REQUEST, N.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function nl(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function ol(t, e) {
  t = t || 10;
  const r = new Array(t), n = new Array(t);
  let i = 0, a = 0, s;
  return e = e !== void 0 ? e : 1e3, function(d) {
    const p = Date.now(), m = n[a];
    s || (s = p), r[i] = d, n[i] = p;
    let P = a, T = 0;
    for (; P !== i; )
      T += r[P++], P = P % t;
    if (i = (i + 1) % t, i === a && (a = (a + 1) % t), p - s < e)
      return;
    const A = m && p - m;
    return A ? Math.round(T * 1e3 / A) : void 0;
  };
}
function il(t, e) {
  let r = 0;
  const n = 1e3 / e;
  let i = null;
  return function() {
    const s = this === !0, u = Date.now();
    if (s || u - r > n)
      return i && (clearTimeout(i), i = null), r = u, t.apply(null, arguments);
    i || (i = setTimeout(() => (i = null, r = Date.now(), t.apply(null, arguments)), n - (u - r)));
  };
}
const Jr = (t, e, r = 3) => {
  let n = 0;
  const i = ol(50, 250);
  return il((a) => {
    const s = a.loaded, u = a.lengthComputable ? a.total : void 0, d = s - n, p = i(d), m = s <= u;
    n = s;
    const P = {
      loaded: s,
      total: u,
      progress: u ? s / u : void 0,
      bytes: d,
      rate: p || void 0,
      estimated: p && u && m ? (u - s) / p : void 0,
      event: a,
      lengthComputable: u != null
    };
    P[e ? "download" : "upload"] = !0, t(P);
  }, r);
}, al = me.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a");
    let n;
    function i(a) {
      let s = a;
      return e && (r.setAttribute("href", s), s = r.href), r.setAttribute("href", s), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return n = i(window.location.href), function(s) {
      const u = S.isString(s) ? i(s) : s;
      return u.protocol === n.protocol && u.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), sl = me.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, r, n, i, a) {
      const s = [t + "=" + encodeURIComponent(e)];
      S.isNumber(r) && s.push("expires=" + new Date(r).toGMTString()), S.isString(n) && s.push("path=" + n), S.isString(i) && s.push("domain=" + i), a === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function cl(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function ul(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function Ca(t, e) {
  return t && !cl(e) ? ul(t, e) : e;
}
const hi = (t) => t instanceof ae ? { ...t } : t;
function qe(t, e) {
  e = e || {};
  const r = {};
  function n(p, m, P) {
    return S.isPlainObject(p) && S.isPlainObject(m) ? S.merge.call({ caseless: P }, p, m) : S.isPlainObject(m) ? S.merge({}, m) : S.isArray(m) ? m.slice() : m;
  }
  function i(p, m, P) {
    if (S.isUndefined(m)) {
      if (!S.isUndefined(p))
        return n(void 0, p, P);
    } else return n(p, m, P);
  }
  function a(p, m) {
    if (!S.isUndefined(m))
      return n(void 0, m);
  }
  function s(p, m) {
    if (S.isUndefined(m)) {
      if (!S.isUndefined(p))
        return n(void 0, p);
    } else return n(void 0, m);
  }
  function u(p, m, P) {
    if (P in e)
      return n(p, m);
    if (P in t)
      return n(void 0, p);
  }
  const d = {
    url: a,
    method: a,
    data: a,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: u,
    headers: (p, m) => i(hi(p), hi(m), !0)
  };
  return S.forEach(Object.keys(Object.assign({}, t, e)), function(m) {
    const P = d[m] || i, T = P(t[m], e[m], m);
    S.isUndefined(T) && P !== u || (r[m] = T);
  }), r;
}
const Na = (t) => {
  const e = qe({}, t);
  let { data: r, withXSRFToken: n, xsrfHeaderName: i, xsrfCookieName: a, headers: s, auth: u } = e;
  e.headers = s = ae.from(s), e.url = Aa(Ca(e.baseURL, e.url), t.params, t.paramsSerializer), u && s.set(
    "Authorization",
    "Basic " + btoa((u.username || "") + ":" + (u.password ? unescape(encodeURIComponent(u.password)) : ""))
  );
  let d;
  if (S.isFormData(r)) {
    if (me.hasStandardBrowserEnv || me.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if ((d = s.getContentType()) !== !1) {
      const [p, ...m] = d ? d.split(";").map((P) => P.trim()).filter(Boolean) : [];
      s.setContentType([p || "multipart/form-data", ...m].join("; "));
    }
  }
  if (me.hasStandardBrowserEnv && (n && S.isFunction(n) && (n = n(e)), n || n !== !1 && al(e.url))) {
    const p = i && a && sl.read(a);
    p && s.set(i, p);
  }
  return e;
}, ll = typeof XMLHttpRequest < "u", fl = ll && function(t) {
  return new Promise(function(r, n) {
    const i = Na(t);
    let a = i.data;
    const s = ae.from(i.headers).normalize();
    let { responseType: u } = i, d;
    function p() {
      i.cancelToken && i.cancelToken.unsubscribe(d), i.signal && i.signal.removeEventListener("abort", d);
    }
    let m = new XMLHttpRequest();
    m.open(i.method.toUpperCase(), i.url, !0), m.timeout = i.timeout;
    function P() {
      if (!m)
        return;
      const A = ae.from(
        "getAllResponseHeaders" in m && m.getAllResponseHeaders()
      ), E = {
        data: !u || u === "text" || u === "json" ? m.responseText : m.response,
        status: m.status,
        statusText: m.statusText,
        headers: A,
        config: t,
        request: m
      };
      _a(function(w) {
        r(w), p();
      }, function(w) {
        n(w), p();
      }, E), m = null;
    }
    "onloadend" in m ? m.onloadend = P : m.onreadystatechange = function() {
      !m || m.readyState !== 4 || m.status === 0 && !(m.responseURL && m.responseURL.indexOf("file:") === 0) || setTimeout(P);
    }, m.onabort = function() {
      m && (n(new N("Request aborted", N.ECONNABORTED, i, m)), m = null);
    }, m.onerror = function() {
      n(new N("Network Error", N.ERR_NETWORK, i, m)), m = null;
    }, m.ontimeout = function() {
      let O = i.timeout ? "timeout of " + i.timeout + "ms exceeded" : "timeout exceeded";
      const E = i.transitional || Ea;
      i.timeoutErrorMessage && (O = i.timeoutErrorMessage), n(new N(
        O,
        E.clarifyTimeoutError ? N.ETIMEDOUT : N.ECONNABORTED,
        i,
        m
      )), m = null;
    }, a === void 0 && s.setContentType(null), "setRequestHeader" in m && S.forEach(s.toJSON(), function(O, E) {
      m.setRequestHeader(E, O);
    }), S.isUndefined(i.withCredentials) || (m.withCredentials = !!i.withCredentials), u && u !== "json" && (m.responseType = i.responseType), typeof i.onDownloadProgress == "function" && m.addEventListener("progress", Jr(i.onDownloadProgress, !0)), typeof i.onUploadProgress == "function" && m.upload && m.upload.addEventListener("progress", Jr(i.onUploadProgress)), (i.cancelToken || i.signal) && (d = (A) => {
      m && (n(!A || A.type ? new Et(null, t, m) : A), m.abort(), m = null);
    }, i.cancelToken && i.cancelToken.subscribe(d), i.signal && (i.signal.aborted ? d() : i.signal.addEventListener("abort", d)));
    const T = nl(i.url);
    if (T && me.protocols.indexOf(T) === -1) {
      n(new N("Unsupported protocol " + T + ":", N.ERR_BAD_REQUEST, t));
      return;
    }
    m.send(a || null);
  });
}, pl = (t, e) => {
  let r = new AbortController(), n;
  const i = function(d) {
    if (!n) {
      n = !0, s();
      const p = d instanceof Error ? d : this.reason;
      r.abort(p instanceof N ? p : new Et(p instanceof Error ? p.message : p));
    }
  };
  let a = e && setTimeout(() => {
    i(new N(`timeout ${e} of ms exceeded`, N.ETIMEDOUT));
  }, e);
  const s = () => {
    t && (a && clearTimeout(a), a = null, t.forEach((d) => {
      d && (d.removeEventListener ? d.removeEventListener("abort", i) : d.unsubscribe(i));
    }), t = null);
  };
  t.forEach((d) => d && d.addEventListener && d.addEventListener("abort", i));
  const { signal: u } = r;
  return u.unsubscribe = s, [u, () => {
    a && clearTimeout(a), a = null;
  }];
}, dl = function* (t, e) {
  let r = t.byteLength;
  if (!e || r < e) {
    yield t;
    return;
  }
  let n = 0, i;
  for (; n < r; )
    i = n + e, yield t.slice(n, i), n = i;
}, hl = async function* (t, e, r) {
  for await (const n of t)
    yield* dl(ArrayBuffer.isView(n) ? n : await r(String(n)), e);
}, yi = (t, e, r, n, i) => {
  const a = hl(t, e, i);
  let s = 0;
  return new ReadableStream({
    type: "bytes",
    async pull(u) {
      const { done: d, value: p } = await a.next();
      if (d) {
        u.close(), n();
        return;
      }
      let m = p.byteLength;
      r && r(s += m), u.enqueue(new Uint8Array(p));
    },
    cancel(u) {
      return n(u), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, mi = (t, e) => {
  const r = t != null;
  return (n) => setTimeout(() => e({
    lengthComputable: r,
    total: t,
    loaded: n
  }));
}, ln = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Ia = ln && typeof ReadableStream == "function", To = ln && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((t) => (e) => t.encode(e))(new TextEncoder()) : async (t) => new Uint8Array(await new Response(t).arrayBuffer())), yl = Ia && (() => {
  let t = !1;
  const e = new Request(me.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type");
  return t && !e;
})(), gi = 64 * 1024, Ao = Ia && !!(() => {
  try {
    return S.isReadableStream(new Response("").body);
  } catch {
  }
})(), Yr = {
  stream: Ao && ((t) => t.body)
};
ln && ((t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !Yr[e] && (Yr[e] = S.isFunction(t[e]) ? (r) => r[e]() : (r, n) => {
      throw new N(`Response type '${e}' is not supported`, N.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const ml = async (t) => {
  if (t == null)
    return 0;
  if (S.isBlob(t))
    return t.size;
  if (S.isSpecCompliantForm(t))
    return (await new Request(t).arrayBuffer()).byteLength;
  if (S.isArrayBufferView(t))
    return t.byteLength;
  if (S.isURLSearchParams(t) && (t = t + ""), S.isString(t))
    return (await To(t)).byteLength;
}, gl = async (t, e) => {
  const r = S.toFiniteNumber(t.getContentLength());
  return r ?? ml(e);
}, bl = ln && (async (t) => {
  let {
    url: e,
    method: r,
    data: n,
    signal: i,
    cancelToken: a,
    timeout: s,
    onDownloadProgress: u,
    onUploadProgress: d,
    responseType: p,
    headers: m,
    withCredentials: P = "same-origin",
    fetchOptions: T
  } = Na(t);
  p = p ? (p + "").toLowerCase() : "text";
  let [A, O] = i || a || s ? pl([i, a], s) : [], E, x;
  const w = () => {
    !E && setTimeout(() => {
      A && A.unsubscribe();
    }), E = !0;
  };
  let b;
  try {
    if (d && yl && r !== "get" && r !== "head" && (b = await gl(m, n)) !== 0) {
      let h = new Request(e, {
        method: "POST",
        body: n,
        duplex: "half"
      }), _;
      S.isFormData(n) && (_ = h.headers.get("content-type")) && m.setContentType(_), h.body && (n = yi(h.body, gi, mi(
        b,
        Jr(d)
      ), null, To));
    }
    S.isString(P) || (P = P ? "cors" : "omit"), x = new Request(e, {
      ...T,
      signal: A,
      method: r.toUpperCase(),
      headers: m.normalize().toJSON(),
      body: n,
      duplex: "half",
      withCredentials: P
    });
    let l = await fetch(x);
    const f = Ao && (p === "stream" || p === "response");
    if (Ao && (u || f)) {
      const h = {};
      ["status", "statusText", "headers"].forEach((K) => {
        h[K] = l[K];
      });
      const _ = S.toFiniteNumber(l.headers.get("content-length"));
      l = new Response(
        yi(l.body, gi, u && mi(
          _,
          Jr(u, !0)
        ), f && w, To),
        h
      );
    }
    p = p || "text";
    let g = await Yr[S.findKey(Yr, p) || "text"](l, t);
    return !f && w(), O && O(), await new Promise((h, _) => {
      _a(h, _, {
        data: g,
        headers: ae.from(l.headers),
        status: l.status,
        statusText: l.statusText,
        config: t,
        request: x
      });
    });
  } catch (l) {
    throw w(), l && l.name === "TypeError" && /fetch/i.test(l.message) ? Object.assign(
      new N("Network Error", N.ERR_NETWORK, t, x),
      {
        cause: l.cause || l
      }
    ) : N.from(l, l && l.code, t, x);
  }
}), Eo = {
  http: Lu,
  xhr: fl,
  fetch: bl
};
S.forEach(Eo, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const bi = (t) => `- ${t}`, wl = (t) => S.isFunction(t) || t === null || t === !1, Da = {
  getAdapter: (t) => {
    t = S.isArray(t) ? t : [t];
    const { length: e } = t;
    let r, n;
    const i = {};
    for (let a = 0; a < e; a++) {
      r = t[a];
      let s;
      if (n = r, !wl(r) && (n = Eo[(s = String(r)).toLowerCase()], n === void 0))
        throw new N(`Unknown adapter '${s}'`);
      if (n)
        break;
      i[s || "#" + a] = n;
    }
    if (!n) {
      const a = Object.entries(i).map(
        ([u, d]) => `adapter ${u} ` + (d === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = e ? a.length > 1 ? `since :
` + a.map(bi).join(`
`) : " " + bi(a[0]) : "as no adapter specified";
      throw new N(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: Eo
};
function so(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new Et(null, t);
}
function wi(t) {
  return so(t), t.headers = ae.from(t.headers), t.data = ao.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), Da.getAdapter(t.adapter || ar.adapter)(t).then(function(n) {
    return so(t), n.data = ao.call(
      t,
      t.transformResponse,
      n
    ), n.headers = ae.from(n.headers), n;
  }, function(n) {
    return Ma(n) || (so(t), n && n.response && (n.response.data = ao.call(
      t,
      t.transformResponse,
      n.response
    ), n.response.headers = ae.from(n.response.headers))), Promise.reject(n);
  });
}
const Ra = "1.7.2", Xo = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  Xo[t] = function(n) {
    return typeof n === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const Si = {};
Xo.transitional = function(e, r, n) {
  function i(a, s) {
    return "[Axios v" + Ra + "] Transitional option '" + a + "'" + s + (n ? ". " + n : "");
  }
  return (a, s, u) => {
    if (e === !1)
      throw new N(
        i(s, " has been removed" + (r ? " in " + r : "")),
        N.ERR_DEPRECATED
      );
    return r && !Si[s] && (Si[s] = !0, console.warn(
      i(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(a, s, u) : !0;
  };
};
function Sl(t, e, r) {
  if (typeof t != "object")
    throw new N("options must be an object", N.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(t);
  let i = n.length;
  for (; i-- > 0; ) {
    const a = n[i], s = e[a];
    if (s) {
      const u = t[a], d = u === void 0 || s(u, a, t);
      if (d !== !0)
        throw new N("option " + a + " must be " + d, N.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new N("Unknown option " + a, N.ERR_BAD_OPTION);
  }
}
const xo = {
  assertOptions: Sl,
  validators: Xo
}, Re = xo.validators;
class Ve {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new pi(),
      response: new pi()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, r) {
    try {
      return await this._request(e, r);
    } catch (n) {
      if (n instanceof Error) {
        let i;
        Error.captureStackTrace ? Error.captureStackTrace(i = {}) : i = new Error();
        const a = i.stack ? i.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? a && !String(n.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + a) : n.stack = a;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(e, r) {
    typeof e == "string" ? (r = r || {}, r.url = e) : r = e || {}, r = qe(this.defaults, r);
    const { transitional: n, paramsSerializer: i, headers: a } = r;
    n !== void 0 && xo.assertOptions(n, {
      silentJSONParsing: Re.transitional(Re.boolean),
      forcedJSONParsing: Re.transitional(Re.boolean),
      clarifyTimeoutError: Re.transitional(Re.boolean)
    }, !1), i != null && (S.isFunction(i) ? r.paramsSerializer = {
      serialize: i
    } : xo.assertOptions(i, {
      encode: Re.function,
      serialize: Re.function
    }, !0)), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = a && S.merge(
      a.common,
      a[r.method]
    );
    a && S.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (O) => {
        delete a[O];
      }
    ), r.headers = ae.concat(s, a);
    const u = [];
    let d = !0;
    this.interceptors.request.forEach(function(E) {
      typeof E.runWhen == "function" && E.runWhen(r) === !1 || (d = d && E.synchronous, u.unshift(E.fulfilled, E.rejected));
    });
    const p = [];
    this.interceptors.response.forEach(function(E) {
      p.push(E.fulfilled, E.rejected);
    });
    let m, P = 0, T;
    if (!d) {
      const O = [wi.bind(this), void 0];
      for (O.unshift.apply(O, u), O.push.apply(O, p), T = O.length, m = Promise.resolve(r); P < T; )
        m = m.then(O[P++], O[P++]);
      return m;
    }
    T = u.length;
    let A = r;
    for (P = 0; P < T; ) {
      const O = u[P++], E = u[P++];
      try {
        A = O(A);
      } catch (x) {
        E.call(this, x);
        break;
      }
    }
    try {
      m = wi.call(this, A);
    } catch (O) {
      return Promise.reject(O);
    }
    for (P = 0, T = p.length; P < T; )
      m = m.then(p[P++], p[P++]);
    return m;
  }
  getUri(e) {
    e = qe(this.defaults, e);
    const r = Ca(e.baseURL, e.url);
    return Aa(r, e.params, e.paramsSerializer);
  }
}
S.forEach(["delete", "get", "head", "options"], function(e) {
  Ve.prototype[e] = function(r, n) {
    return this.request(qe(n || {}, {
      method: e,
      url: r,
      data: (n || {}).data
    }));
  };
});
S.forEach(["post", "put", "patch"], function(e) {
  function r(n) {
    return function(a, s, u) {
      return this.request(qe(u || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: s
      }));
    };
  }
  Ve.prototype[e] = r(), Ve.prototype[e + "Form"] = r(!0);
});
class $o {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(a) {
      r = a;
    });
    const n = this;
    this.promise.then((i) => {
      if (!n._listeners) return;
      let a = n._listeners.length;
      for (; a-- > 0; )
        n._listeners[a](i);
      n._listeners = null;
    }), this.promise.then = (i) => {
      let a;
      const s = new Promise((u) => {
        n.subscribe(u), a = u;
      }).then(i);
      return s.cancel = function() {
        n.unsubscribe(a);
      }, s;
    }, e(function(a, s, u) {
      n.reason || (n.reason = new Et(a, s, u), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(e);
    r !== -1 && this._listeners.splice(r, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new $o(function(i) {
        e = i;
      }),
      cancel: e
    };
  }
}
function vl(t) {
  return function(r) {
    return t.apply(null, r);
  };
}
function Pl(t) {
  return S.isObject(t) && t.isAxiosError === !0;
}
const Mo = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Mo).forEach(([t, e]) => {
  Mo[e] = t;
});
function La(t) {
  const e = new Ve(t), r = da(Ve.prototype.request, e);
  return S.extend(r, Ve.prototype, e, { allOwnKeys: !0 }), S.extend(r, e, null, { allOwnKeys: !0 }), r.create = function(i) {
    return La(qe(t, i));
  }, r;
}
const G = La(ar);
G.Axios = Ve;
G.CanceledError = Et;
G.CancelToken = $o;
G.isCancel = Ma;
G.VERSION = Ra;
G.toFormData = un;
G.AxiosError = N;
G.Cancel = G.CanceledError;
G.all = function(e) {
  return Promise.all(e);
};
G.spread = vl;
G.isAxiosError = Pl;
G.mergeConfig = qe;
G.AxiosHeaders = ae;
G.formToJSON = (t) => xa(S.isHTMLForm(t) ? new FormData(t) : t);
G.getAdapter = Da.getAdapter;
G.HttpStatusCode = Mo;
G.default = G;
var Ol = Error, Tl = EvalError, Al = RangeError, El = ReferenceError, ja = SyntaxError, sr = TypeError, xl = URIError, Ml = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, r = Symbol("test"), n = Object(r);
  if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
    return !1;
  var i = 42;
  e[r] = i;
  for (r in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var a = Object.getOwnPropertySymbols(e);
  if (a.length !== 1 || a[0] !== r || !Object.prototype.propertyIsEnumerable.call(e, r))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var s = Object.getOwnPropertyDescriptor(e, r);
    if (s.value !== i || s.enumerable !== !0)
      return !1;
  }
  return !0;
}, vi = typeof Symbol < "u" && Symbol, _l = Ml, Cl = function() {
  return typeof vi != "function" || typeof Symbol != "function" || typeof vi("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : _l();
}, co = {
  __proto__: null,
  foo: {}
}, Nl = Object, Il = function() {
  return { __proto__: co }.foo === co.foo && !(co instanceof Nl);
}, Dl = "Function.prototype.bind called on incompatible ", Rl = Object.prototype.toString, Ll = Math.max, jl = "[object Function]", Pi = function(e, r) {
  for (var n = [], i = 0; i < e.length; i += 1)
    n[i] = e[i];
  for (var a = 0; a < r.length; a += 1)
    n[a + e.length] = r[a];
  return n;
}, Kl = function(e, r) {
  for (var n = [], i = r, a = 0; i < e.length; i += 1, a += 1)
    n[a] = e[i];
  return n;
}, Fl = function(t, e) {
  for (var r = "", n = 0; n < t.length; n += 1)
    r += t[n], n + 1 < t.length && (r += e);
  return r;
}, Ul = function(e) {
  var r = this;
  if (typeof r != "function" || Rl.apply(r) !== jl)
    throw new TypeError(Dl + r);
  for (var n = Kl(arguments, 1), i, a = function() {
    if (this instanceof i) {
      var m = r.apply(
        this,
        Pi(n, arguments)
      );
      return Object(m) === m ? m : this;
    }
    return r.apply(
      e,
      Pi(n, arguments)
    );
  }, s = Ll(0, r.length - n.length), u = [], d = 0; d < s; d++)
    u[d] = "$" + d;
  if (i = Function("binder", "return function (" + Fl(u, ",") + "){ return binder.apply(this,arguments); }")(a), r.prototype) {
    var p = function() {
    };
    p.prototype = r.prototype, i.prototype = new p(), p.prototype = null;
  }
  return i;
}, Gl = Ul, ko = Function.prototype.bind || Gl, Zl = Function.prototype.call, zl = Object.prototype.hasOwnProperty, Hl = ko, Bl = Hl.call(Zl, zl), I, Xl = Ol, $l = Tl, kl = Al, Wl = El, St = ja, wt = sr, Vl = xl, Ka = Function, uo = function(t) {
  try {
    return Ka('"use strict"; return (' + t + ").constructor;")();
  } catch {
  }
}, Je = Object.getOwnPropertyDescriptor;
if (Je)
  try {
    Je({}, "");
  } catch {
    Je = null;
  }
var lo = function() {
  throw new wt();
}, Jl = Je ? function() {
  try {
    return arguments.callee, lo;
  } catch {
    try {
      return Je(arguments, "callee").get;
    } catch {
      return lo;
    }
  }
}() : lo, ht = Cl(), Yl = Il(), $ = Object.getPrototypeOf || (Yl ? function(t) {
  return t.__proto__;
} : null), gt = {}, Ql = typeof Uint8Array > "u" || !$ ? I : $(Uint8Array), Ye = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? I : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? I : ArrayBuffer,
  "%ArrayIteratorPrototype%": ht && $ ? $([][Symbol.iterator]()) : I,
  "%AsyncFromSyncIteratorPrototype%": I,
  "%AsyncFunction%": gt,
  "%AsyncGenerator%": gt,
  "%AsyncGeneratorFunction%": gt,
  "%AsyncIteratorPrototype%": gt,
  "%Atomics%": typeof Atomics > "u" ? I : Atomics,
  "%BigInt%": typeof BigInt > "u" ? I : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? I : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? I : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? I : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Xl,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": $l,
  "%Float32Array%": typeof Float32Array > "u" ? I : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? I : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? I : FinalizationRegistry,
  "%Function%": Ka,
  "%GeneratorFunction%": gt,
  "%Int8Array%": typeof Int8Array > "u" ? I : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? I : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? I : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": ht && $ ? $($([][Symbol.iterator]())) : I,
  "%JSON%": typeof JSON == "object" ? JSON : I,
  "%Map%": typeof Map > "u" ? I : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !ht || !$ ? I : $((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? I : Promise,
  "%Proxy%": typeof Proxy > "u" ? I : Proxy,
  "%RangeError%": kl,
  "%ReferenceError%": Wl,
  "%Reflect%": typeof Reflect > "u" ? I : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? I : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !ht || !$ ? I : $((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? I : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": ht && $ ? $(""[Symbol.iterator]()) : I,
  "%Symbol%": ht ? Symbol : I,
  "%SyntaxError%": St,
  "%ThrowTypeError%": Jl,
  "%TypedArray%": Ql,
  "%TypeError%": wt,
  "%Uint8Array%": typeof Uint8Array > "u" ? I : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? I : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? I : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? I : Uint32Array,
  "%URIError%": Vl,
  "%WeakMap%": typeof WeakMap > "u" ? I : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? I : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? I : WeakSet
};
if ($)
  try {
    null.error;
  } catch (t) {
    var ql = $($(t));
    Ye["%Error.prototype%"] = ql;
  }
var ef = function t(e) {
  var r;
  if (e === "%AsyncFunction%")
    r = uo("async function () {}");
  else if (e === "%GeneratorFunction%")
    r = uo("function* () {}");
  else if (e === "%AsyncGeneratorFunction%")
    r = uo("async function* () {}");
  else if (e === "%AsyncGenerator%") {
    var n = t("%AsyncGeneratorFunction%");
    n && (r = n.prototype);
  } else if (e === "%AsyncIteratorPrototype%") {
    var i = t("%AsyncGenerator%");
    i && $ && (r = $(i.prototype));
  }
  return Ye[e] = r, r;
}, Oi = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, cr = ko, Qr = Bl, tf = cr.call(Function.call, Array.prototype.concat), rf = cr.call(Function.apply, Array.prototype.splice), Ti = cr.call(Function.call, String.prototype.replace), qr = cr.call(Function.call, String.prototype.slice), nf = cr.call(Function.call, RegExp.prototype.exec), of = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, af = /\\(\\)?/g, sf = function(e) {
  var r = qr(e, 0, 1), n = qr(e, -1);
  if (r === "%" && n !== "%")
    throw new St("invalid intrinsic syntax, expected closing `%`");
  if (n === "%" && r !== "%")
    throw new St("invalid intrinsic syntax, expected opening `%`");
  var i = [];
  return Ti(e, of, function(a, s, u, d) {
    i[i.length] = u ? Ti(d, af, "$1") : s || a;
  }), i;
}, cf = function(e, r) {
  var n = e, i;
  if (Qr(Oi, n) && (i = Oi[n], n = "%" + i[0] + "%"), Qr(Ye, n)) {
    var a = Ye[n];
    if (a === gt && (a = ef(n)), typeof a > "u" && !r)
      throw new wt("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: i,
      name: n,
      value: a
    };
  }
  throw new St("intrinsic " + e + " does not exist!");
}, xt = function(e, r) {
  if (typeof e != "string" || e.length === 0)
    throw new wt("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof r != "boolean")
    throw new wt('"allowMissing" argument must be a boolean');
  if (nf(/^%?[^%]*%?$/, e) === null)
    throw new St("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var n = sf(e), i = n.length > 0 ? n[0] : "", a = cf("%" + i + "%", r), s = a.name, u = a.value, d = !1, p = a.alias;
  p && (i = p[0], rf(n, tf([0, 1], p)));
  for (var m = 1, P = !0; m < n.length; m += 1) {
    var T = n[m], A = qr(T, 0, 1), O = qr(T, -1);
    if ((A === '"' || A === "'" || A === "`" || O === '"' || O === "'" || O === "`") && A !== O)
      throw new St("property names with quotes must have matching quotes");
    if ((T === "constructor" || !P) && (d = !0), i += "." + T, s = "%" + i + "%", Qr(Ye, s))
      u = Ye[s];
    else if (u != null) {
      if (!(T in u)) {
        if (!r)
          throw new wt("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if (Je && m + 1 >= n.length) {
        var E = Je(u, T);
        P = !!E, P && "get" in E && !("originalValue" in E.get) ? u = E.get : u = u[T];
      } else
        P = Qr(u, T), u = u[T];
      P && !d && (Ye[s] = u);
    }
  }
  return u;
}, Fa = { exports: {} }, fo, Ai;
function Wo() {
  if (Ai) return fo;
  Ai = 1;
  var t = xt, e = t("%Object.defineProperty%", !0) || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return fo = e, fo;
}
var uf = xt, Br = uf("%Object.getOwnPropertyDescriptor%", !0);
if (Br)
  try {
    Br([], "length");
  } catch {
    Br = null;
  }
var Ua = Br, Ei = Wo(), lf = ja, yt = sr, xi = Ua, ff = function(e, r, n) {
  if (!e || typeof e != "object" && typeof e != "function")
    throw new yt("`obj` must be an object or a function`");
  if (typeof r != "string" && typeof r != "symbol")
    throw new yt("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new yt("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new yt("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new yt("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new yt("`loose`, if provided, must be a boolean");
  var i = arguments.length > 3 ? arguments[3] : null, a = arguments.length > 4 ? arguments[4] : null, s = arguments.length > 5 ? arguments[5] : null, u = arguments.length > 6 ? arguments[6] : !1, d = !!xi && xi(e, r);
  if (Ei)
    Ei(e, r, {
      configurable: s === null && d ? d.configurable : !s,
      enumerable: i === null && d ? d.enumerable : !i,
      value: n,
      writable: a === null && d ? d.writable : !a
    });
  else if (u || !i && !a && !s)
    e[r] = n;
  else
    throw new lf("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, _o = Wo(), Ga = function() {
  return !!_o;
};
Ga.hasArrayLengthDefineBug = function() {
  if (!_o)
    return null;
  try {
    return _o([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var pf = Ga, df = xt, Mi = ff, hf = pf(), _i = Ua, Ci = sr, yf = df("%Math.floor%"), mf = function(e, r) {
  if (typeof e != "function")
    throw new Ci("`fn` is not a function");
  if (typeof r != "number" || r < 0 || r > 4294967295 || yf(r) !== r)
    throw new Ci("`length` must be a positive 32-bit integer");
  var n = arguments.length > 2 && !!arguments[2], i = !0, a = !0;
  if ("length" in e && _i) {
    var s = _i(e, "length");
    s && !s.configurable && (i = !1), s && !s.writable && (a = !1);
  }
  return (i || a || !n) && (hf ? Mi(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    r,
    !0,
    !0
  ) : Mi(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    r
  )), e;
};
(function(t) {
  var e = ko, r = xt, n = mf, i = sr, a = r("%Function.prototype.apply%"), s = r("%Function.prototype.call%"), u = r("%Reflect.apply%", !0) || e.call(s, a), d = Wo(), p = r("%Math.max%");
  t.exports = function(T) {
    if (typeof T != "function")
      throw new i("a function is required");
    var A = u(e, s, arguments);
    return n(
      A,
      1 + p(0, T.length - (arguments.length - 1)),
      !0
    );
  };
  var m = function() {
    return u(e, a, arguments);
  };
  d ? d(t.exports, "apply", { value: m }) : t.exports.apply = m;
})(Fa);
var gf = Fa.exports, Za = xt, za = gf, bf = za(Za("String.prototype.indexOf")), wf = function(e, r) {
  var n = Za(e, !!r);
  return typeof n == "function" && bf(e, ".prototype.") > -1 ? za(n) : n;
};
const Sf = {}, vf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Sf
}, Symbol.toStringTag, { value: "Module" })), Pf = /* @__PURE__ */ cs(vf);
var Vo = typeof Map == "function" && Map.prototype, po = Object.getOwnPropertyDescriptor && Vo ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, en = Vo && po && typeof po.get == "function" ? po.get : null, Ni = Vo && Map.prototype.forEach, Jo = typeof Set == "function" && Set.prototype, ho = Object.getOwnPropertyDescriptor && Jo ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, tn = Jo && ho && typeof ho.get == "function" ? ho.get : null, Ii = Jo && Set.prototype.forEach, Of = typeof WeakMap == "function" && WeakMap.prototype, er = Of ? WeakMap.prototype.has : null, Tf = typeof WeakSet == "function" && WeakSet.prototype, tr = Tf ? WeakSet.prototype.has : null, Af = typeof WeakRef == "function" && WeakRef.prototype, Di = Af ? WeakRef.prototype.deref : null, Ef = Boolean.prototype.valueOf, xf = Object.prototype.toString, Mf = Function.prototype.toString, _f = String.prototype.match, Yo = String.prototype.slice, Ke = String.prototype.replace, Cf = String.prototype.toUpperCase, Ri = String.prototype.toLowerCase, Ha = RegExp.prototype.test, Li = Array.prototype.concat, Ee = Array.prototype.join, Nf = Array.prototype.slice, ji = Math.floor, Co = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, yo = Object.getOwnPropertySymbols, No = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, vt = typeof Symbol == "function" && typeof Symbol.iterator == "object", ee = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === vt || !0) ? Symbol.toStringTag : null, Ba = Object.prototype.propertyIsEnumerable, Ki = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(t) {
  return t.__proto__;
} : null);
function Fi(t, e) {
  if (t === 1 / 0 || t === -1 / 0 || t !== t || t && t > -1e3 && t < 1e3 || Ha.call(/e/, e))
    return e;
  var r = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof t == "number") {
    var n = t < 0 ? -ji(-t) : ji(t);
    if (n !== t) {
      var i = String(n), a = Yo.call(e, i.length + 1);
      return Ke.call(i, r, "$&_") + "." + Ke.call(Ke.call(a, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return Ke.call(e, r, "$&_");
}
var Io = Pf, Ui = Io.custom, Gi = $a(Ui) ? Ui : null, If = function t(e, r, n, i) {
  var a = r || {};
  if (je(a, "quoteStyle") && a.quoteStyle !== "single" && a.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (je(a, "maxStringLength") && (typeof a.maxStringLength == "number" ? a.maxStringLength < 0 && a.maxStringLength !== 1 / 0 : a.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var s = je(a, "customInspect") ? a.customInspect : !0;
  if (typeof s != "boolean" && s !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (je(a, "indent") && a.indent !== null && a.indent !== "	" && !(parseInt(a.indent, 10) === a.indent && a.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (je(a, "numericSeparator") && typeof a.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var u = a.numericSeparator;
  if (typeof e > "u")
    return "undefined";
  if (e === null)
    return "null";
  if (typeof e == "boolean")
    return e ? "true" : "false";
  if (typeof e == "string")
    return Wa(e, a);
  if (typeof e == "number") {
    if (e === 0)
      return 1 / 0 / e > 0 ? "0" : "-0";
    var d = String(e);
    return u ? Fi(e, d) : d;
  }
  if (typeof e == "bigint") {
    var p = String(e) + "n";
    return u ? Fi(e, p) : p;
  }
  var m = typeof a.depth > "u" ? 5 : a.depth;
  if (typeof n > "u" && (n = 0), n >= m && m > 0 && typeof e == "object")
    return Do(e) ? "[Array]" : "[Object]";
  var P = Jf(a, n);
  if (typeof i > "u")
    i = [];
  else if (ka(i, e) >= 0)
    return "[Circular]";
  function T(J, se, ce) {
    if (se && (i = Nf.call(i), i.push(se)), ce) {
      var xe = {
        depth: a.depth
      };
      return je(a, "quoteStyle") && (xe.quoteStyle = a.quoteStyle), t(J, xe, n + 1, i);
    }
    return t(J, a, n + 1, i);
  }
  if (typeof e == "function" && !Zi(e)) {
    var A = Zf(e), O = jr(e, T);
    return "[Function" + (A ? ": " + A : " (anonymous)") + "]" + (O.length > 0 ? " { " + Ee.call(O, ", ") + " }" : "");
  }
  if ($a(e)) {
    var E = vt ? Ke.call(String(e), /^(Symbol\(.*\))_[^)]*$/, "$1") : No.call(e);
    return typeof e == "object" && !vt ? Jt(E) : E;
  }
  if (kf(e)) {
    for (var x = "<" + Ri.call(String(e.nodeName)), w = e.attributes || [], b = 0; b < w.length; b++)
      x += " " + w[b].name + "=" + Xa(Df(w[b].value), "double", a);
    return x += ">", e.childNodes && e.childNodes.length && (x += "..."), x += "</" + Ri.call(String(e.nodeName)) + ">", x;
  }
  if (Do(e)) {
    if (e.length === 0)
      return "[]";
    var l = jr(e, T);
    return P && !Vf(l) ? "[" + Ro(l, P) + "]" : "[ " + Ee.call(l, ", ") + " ]";
  }
  if (Lf(e)) {
    var f = jr(e, T);
    return !("cause" in Error.prototype) && "cause" in e && !Ba.call(e, "cause") ? "{ [" + String(e) + "] " + Ee.call(Li.call("[cause]: " + T(e.cause), f), ", ") + " }" : f.length === 0 ? "[" + String(e) + "]" : "{ [" + String(e) + "] " + Ee.call(f, ", ") + " }";
  }
  if (typeof e == "object" && s) {
    if (Gi && typeof e[Gi] == "function" && Io)
      return Io(e, { depth: m - n });
    if (s !== "symbol" && typeof e.inspect == "function")
      return e.inspect();
  }
  if (zf(e)) {
    var g = [];
    return Ni && Ni.call(e, function(J, se) {
      g.push(T(se, e, !0) + " => " + T(J, e));
    }), zi("Map", en.call(e), g, P);
  }
  if (Xf(e)) {
    var h = [];
    return Ii && Ii.call(e, function(J) {
      h.push(T(J, e));
    }), zi("Set", tn.call(e), h, P);
  }
  if (Hf(e))
    return mo("WeakMap");
  if ($f(e))
    return mo("WeakSet");
  if (Bf(e))
    return mo("WeakRef");
  if (Kf(e))
    return Jt(T(Number(e)));
  if (Uf(e))
    return Jt(T(Co.call(e)));
  if (Ff(e))
    return Jt(Ef.call(e));
  if (jf(e))
    return Jt(T(String(e)));
  if (typeof window < "u" && e === window)
    return "{ [object Window] }";
  if (e === V)
    return "{ [object globalThis] }";
  if (!Rf(e) && !Zi(e)) {
    var _ = jr(e, T), K = Ki ? Ki(e) === Object.prototype : e instanceof Object || e.constructor === Object, U = e instanceof Object ? "" : "null prototype", X = !K && ee && Object(e) === e && ee in e ? Yo.call(Fe(e), 8, -1) : U ? "Object" : "", we = K || typeof e.constructor != "function" ? "" : e.constructor.name ? e.constructor.name + " " : "", ne = we + (X || U ? "[" + Ee.call(Li.call([], X || [], U || []), ": ") + "] " : "");
    return _.length === 0 ? ne + "{}" : P ? ne + "{" + Ro(_, P) + "}" : ne + "{ " + Ee.call(_, ", ") + " }";
  }
  return String(e);
};
function Xa(t, e, r) {
  var n = (r.quoteStyle || e) === "double" ? '"' : "'";
  return n + t + n;
}
function Df(t) {
  return Ke.call(String(t), /"/g, "&quot;");
}
function Do(t) {
  return Fe(t) === "[object Array]" && (!ee || !(typeof t == "object" && ee in t));
}
function Rf(t) {
  return Fe(t) === "[object Date]" && (!ee || !(typeof t == "object" && ee in t));
}
function Zi(t) {
  return Fe(t) === "[object RegExp]" && (!ee || !(typeof t == "object" && ee in t));
}
function Lf(t) {
  return Fe(t) === "[object Error]" && (!ee || !(typeof t == "object" && ee in t));
}
function jf(t) {
  return Fe(t) === "[object String]" && (!ee || !(typeof t == "object" && ee in t));
}
function Kf(t) {
  return Fe(t) === "[object Number]" && (!ee || !(typeof t == "object" && ee in t));
}
function Ff(t) {
  return Fe(t) === "[object Boolean]" && (!ee || !(typeof t == "object" && ee in t));
}
function $a(t) {
  if (vt)
    return t && typeof t == "object" && t instanceof Symbol;
  if (typeof t == "symbol")
    return !0;
  if (!t || typeof t != "object" || !No)
    return !1;
  try {
    return No.call(t), !0;
  } catch {
  }
  return !1;
}
function Uf(t) {
  if (!t || typeof t != "object" || !Co)
    return !1;
  try {
    return Co.call(t), !0;
  } catch {
  }
  return !1;
}
var Gf = Object.prototype.hasOwnProperty || function(t) {
  return t in this;
};
function je(t, e) {
  return Gf.call(t, e);
}
function Fe(t) {
  return xf.call(t);
}
function Zf(t) {
  if (t.name)
    return t.name;
  var e = _f.call(Mf.call(t), /^function\s*([\w$]+)/);
  return e ? e[1] : null;
}
function ka(t, e) {
  if (t.indexOf)
    return t.indexOf(e);
  for (var r = 0, n = t.length; r < n; r++)
    if (t[r] === e)
      return r;
  return -1;
}
function zf(t) {
  if (!en || !t || typeof t != "object")
    return !1;
  try {
    en.call(t);
    try {
      tn.call(t);
    } catch {
      return !0;
    }
    return t instanceof Map;
  } catch {
  }
  return !1;
}
function Hf(t) {
  if (!er || !t || typeof t != "object")
    return !1;
  try {
    er.call(t, er);
    try {
      tr.call(t, tr);
    } catch {
      return !0;
    }
    return t instanceof WeakMap;
  } catch {
  }
  return !1;
}
function Bf(t) {
  if (!Di || !t || typeof t != "object")
    return !1;
  try {
    return Di.call(t), !0;
  } catch {
  }
  return !1;
}
function Xf(t) {
  if (!tn || !t || typeof t != "object")
    return !1;
  try {
    tn.call(t);
    try {
      en.call(t);
    } catch {
      return !0;
    }
    return t instanceof Set;
  } catch {
  }
  return !1;
}
function $f(t) {
  if (!tr || !t || typeof t != "object")
    return !1;
  try {
    tr.call(t, tr);
    try {
      er.call(t, er);
    } catch {
      return !0;
    }
    return t instanceof WeakSet;
  } catch {
  }
  return !1;
}
function kf(t) {
  return !t || typeof t != "object" ? !1 : typeof HTMLElement < "u" && t instanceof HTMLElement ? !0 : typeof t.nodeName == "string" && typeof t.getAttribute == "function";
}
function Wa(t, e) {
  if (t.length > e.maxStringLength) {
    var r = t.length - e.maxStringLength, n = "... " + r + " more character" + (r > 1 ? "s" : "");
    return Wa(Yo.call(t, 0, e.maxStringLength), e) + n;
  }
  var i = Ke.call(Ke.call(t, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, Wf);
  return Xa(i, "single", e);
}
function Wf(t) {
  var e = t.charCodeAt(0), r = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[e];
  return r ? "\\" + r : "\\x" + (e < 16 ? "0" : "") + Cf.call(e.toString(16));
}
function Jt(t) {
  return "Object(" + t + ")";
}
function mo(t) {
  return t + " { ? }";
}
function zi(t, e, r, n) {
  var i = n ? Ro(r, n) : Ee.call(r, ", ");
  return t + " (" + e + ") {" + i + "}";
}
function Vf(t) {
  for (var e = 0; e < t.length; e++)
    if (ka(t[e], `
`) >= 0)
      return !1;
  return !0;
}
function Jf(t, e) {
  var r;
  if (t.indent === "	")
    r = "	";
  else if (typeof t.indent == "number" && t.indent > 0)
    r = Ee.call(Array(t.indent + 1), " ");
  else
    return null;
  return {
    base: r,
    prev: Ee.call(Array(e + 1), r)
  };
}
function Ro(t, e) {
  if (t.length === 0)
    return "";
  var r = `
` + e.prev + e.base;
  return r + Ee.call(t, "," + r) + `
` + e.prev;
}
function jr(t, e) {
  var r = Do(t), n = [];
  if (r) {
    n.length = t.length;
    for (var i = 0; i < t.length; i++)
      n[i] = je(t, i) ? e(t[i], t) : "";
  }
  var a = typeof yo == "function" ? yo(t) : [], s;
  if (vt) {
    s = {};
    for (var u = 0; u < a.length; u++)
      s["$" + a[u]] = a[u];
  }
  for (var d in t)
    je(t, d) && (r && String(Number(d)) === d && d < t.length || vt && s["$" + d] instanceof Symbol || (Ha.call(/[^\w$]/, d) ? n.push(e(d, t) + ": " + e(t[d], t)) : n.push(d + ": " + e(t[d], t))));
  if (typeof yo == "function")
    for (var p = 0; p < a.length; p++)
      Ba.call(t, a[p]) && n.push("[" + e(a[p]) + "]: " + e(t[a[p]], t));
  return n;
}
var Va = xt, Mt = wf, Yf = If, Qf = sr, Kr = Va("%WeakMap%", !0), Fr = Va("%Map%", !0), qf = Mt("WeakMap.prototype.get", !0), ep = Mt("WeakMap.prototype.set", !0), tp = Mt("WeakMap.prototype.has", !0), rp = Mt("Map.prototype.get", !0), np = Mt("Map.prototype.set", !0), op = Mt("Map.prototype.has", !0), Qo = function(t, e) {
  for (var r = t, n; (n = r.next) !== null; r = n)
    if (n.key === e)
      return r.next = n.next, n.next = /** @type {NonNullable<typeof list.next>} */
      t.next, t.next = n, n;
}, ip = function(t, e) {
  var r = Qo(t, e);
  return r && r.value;
}, ap = function(t, e, r) {
  var n = Qo(t, e);
  n ? n.value = r : t.next = /** @type {import('.').ListNode<typeof value>} */
  {
    // eslint-disable-line no-param-reassign, no-extra-parens
    key: e,
    next: t.next,
    value: r
  };
}, sp = function(t, e) {
  return !!Qo(t, e);
}, cp = function() {
  var e, r, n, i = {
    assert: function(a) {
      if (!i.has(a))
        throw new Qf("Side channel does not contain " + Yf(a));
    },
    get: function(a) {
      if (Kr && a && (typeof a == "object" || typeof a == "function")) {
        if (e)
          return qf(e, a);
      } else if (Fr) {
        if (r)
          return rp(r, a);
      } else if (n)
        return ip(n, a);
    },
    has: function(a) {
      if (Kr && a && (typeof a == "object" || typeof a == "function")) {
        if (e)
          return tp(e, a);
      } else if (Fr) {
        if (r)
          return op(r, a);
      } else if (n)
        return sp(n, a);
      return !1;
    },
    set: function(a, s) {
      Kr && a && (typeof a == "object" || typeof a == "function") ? (e || (e = new Kr()), ep(e, a, s)) : Fr ? (r || (r = new Fr()), np(r, a, s)) : (n || (n = { key: {}, next: null }), ap(n, a, s));
    }
  };
  return i;
}, up = String.prototype.replace, lp = /%20/g, go = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, qo = {
  default: go.RFC3986,
  formatters: {
    RFC1738: function(t) {
      return up.call(t, lp, "+");
    },
    RFC3986: function(t) {
      return String(t);
    }
  },
  RFC1738: go.RFC1738,
  RFC3986: go.RFC3986
}, fp = qo, bo = Object.prototype.hasOwnProperty, We = Array.isArray, Te = function() {
  for (var t = [], e = 0; e < 256; ++e)
    t.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
  return t;
}(), pp = function(e) {
  for (; e.length > 1; ) {
    var r = e.pop(), n = r.obj[r.prop];
    if (We(n)) {
      for (var i = [], a = 0; a < n.length; ++a)
        typeof n[a] < "u" && i.push(n[a]);
      r.obj[r.prop] = i;
    }
  }
}, Ja = function(e, r) {
  for (var n = r && r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, i = 0; i < e.length; ++i)
    typeof e[i] < "u" && (n[i] = e[i]);
  return n;
}, dp = function t(e, r, n) {
  if (!r)
    return e;
  if (typeof r != "object") {
    if (We(e))
      e.push(r);
    else if (e && typeof e == "object")
      (n && (n.plainObjects || n.allowPrototypes) || !bo.call(Object.prototype, r)) && (e[r] = !0);
    else
      return [e, r];
    return e;
  }
  if (!e || typeof e != "object")
    return [e].concat(r);
  var i = e;
  return We(e) && !We(r) && (i = Ja(e, n)), We(e) && We(r) ? (r.forEach(function(a, s) {
    if (bo.call(e, s)) {
      var u = e[s];
      u && typeof u == "object" && a && typeof a == "object" ? e[s] = t(u, a, n) : e.push(a);
    } else
      e[s] = a;
  }), e) : Object.keys(r).reduce(function(a, s) {
    var u = r[s];
    return bo.call(a, s) ? a[s] = t(a[s], u, n) : a[s] = u, a;
  }, i);
}, hp = function(e, r) {
  return Object.keys(r).reduce(function(n, i) {
    return n[i] = r[i], n;
  }, e);
}, yp = function(t, e, r) {
  var n = t.replace(/\+/g, " ");
  if (r === "iso-8859-1")
    return n.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(n);
  } catch {
    return n;
  }
}, mp = function(e, r, n, i, a) {
  if (e.length === 0)
    return e;
  var s = e;
  if (typeof e == "symbol" ? s = Symbol.prototype.toString.call(e) : typeof e != "string" && (s = String(e)), n === "iso-8859-1")
    return escape(s).replace(/%u[0-9a-f]{4}/gi, function(m) {
      return "%26%23" + parseInt(m.slice(2), 16) + "%3B";
    });
  for (var u = "", d = 0; d < s.length; ++d) {
    var p = s.charCodeAt(d);
    if (p === 45 || p === 46 || p === 95 || p === 126 || p >= 48 && p <= 57 || p >= 65 && p <= 90 || p >= 97 && p <= 122 || a === fp.RFC1738 && (p === 40 || p === 41)) {
      u += s.charAt(d);
      continue;
    }
    if (p < 128) {
      u = u + Te[p];
      continue;
    }
    if (p < 2048) {
      u = u + (Te[192 | p >> 6] + Te[128 | p & 63]);
      continue;
    }
    if (p < 55296 || p >= 57344) {
      u = u + (Te[224 | p >> 12] + Te[128 | p >> 6 & 63] + Te[128 | p & 63]);
      continue;
    }
    d += 1, p = 65536 + ((p & 1023) << 10 | s.charCodeAt(d) & 1023), u += Te[240 | p >> 18] + Te[128 | p >> 12 & 63] + Te[128 | p >> 6 & 63] + Te[128 | p & 63];
  }
  return u;
}, gp = function(e) {
  for (var r = [{ obj: { o: e }, prop: "o" }], n = [], i = 0; i < r.length; ++i)
    for (var a = r[i], s = a.obj[a.prop], u = Object.keys(s), d = 0; d < u.length; ++d) {
      var p = u[d], m = s[p];
      typeof m == "object" && m !== null && n.indexOf(m) === -1 && (r.push({ obj: s, prop: p }), n.push(m));
    }
  return pp(r), e;
}, bp = function(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}, wp = function(e) {
  return !e || typeof e != "object" ? !1 : !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
}, Sp = function(e, r) {
  return [].concat(e, r);
}, vp = function(e, r) {
  if (We(e)) {
    for (var n = [], i = 0; i < e.length; i += 1)
      n.push(r(e[i]));
    return n;
  }
  return r(e);
}, Ya = {
  arrayToObject: Ja,
  assign: hp,
  combine: Sp,
  compact: gp,
  decode: yp,
  encode: mp,
  isBuffer: wp,
  isRegExp: bp,
  maybeMap: vp,
  merge: dp
}, Qa = cp, Xr = Ya, rr = qo, Pp = Object.prototype.hasOwnProperty, qa = {
  brackets: function(e) {
    return e + "[]";
  },
  comma: "comma",
  indices: function(e, r) {
    return e + "[" + r + "]";
  },
  repeat: function(e) {
    return e;
  }
}, Ae = Array.isArray, Op = Array.prototype.push, es = function(t, e) {
  Op.apply(t, Ae(e) ? e : [e]);
}, Tp = Date.prototype.toISOString, Hi = rr.default, B = {
  addQueryPrefix: !1,
  allowDots: !1,
  allowEmptyArrays: !1,
  arrayFormat: "indices",
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encodeDotInKeys: !1,
  encoder: Xr.encode,
  encodeValuesOnly: !1,
  format: Hi,
  formatter: rr.formatters[Hi],
  // deprecated
  indices: !1,
  serializeDate: function(e) {
    return Tp.call(e);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, Ap = function(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "symbol" || typeof e == "bigint";
}, wo = {}, Ep = function t(e, r, n, i, a, s, u, d, p, m, P, T, A, O, E, x, w, b) {
  for (var l = e, f = b, g = 0, h = !1; (f = f.get(wo)) !== void 0 && !h; ) {
    var _ = f.get(e);
    if (g += 1, typeof _ < "u") {
      if (_ === g)
        throw new RangeError("Cyclic object value");
      h = !0;
    }
    typeof f.get(wo) > "u" && (g = 0);
  }
  if (typeof m == "function" ? l = m(r, l) : l instanceof Date ? l = A(l) : n === "comma" && Ae(l) && (l = Xr.maybeMap(l, function(R) {
    return R instanceof Date ? A(R) : R;
  })), l === null) {
    if (s)
      return p && !x ? p(r, B.encoder, w, "key", O) : r;
    l = "";
  }
  if (Ap(l) || Xr.isBuffer(l)) {
    if (p) {
      var K = x ? r : p(r, B.encoder, w, "key", O);
      return [E(K) + "=" + E(p(l, B.encoder, w, "value", O))];
    }
    return [E(r) + "=" + E(String(l))];
  }
  var U = [];
  if (typeof l > "u")
    return U;
  var X;
  if (n === "comma" && Ae(l))
    x && p && (l = Xr.maybeMap(l, p)), X = [{ value: l.length > 0 ? l.join(",") || null : void 0 }];
  else if (Ae(m))
    X = m;
  else {
    var we = Object.keys(l);
    X = P ? we.sort(P) : we;
  }
  var ne = d ? r.replace(/\./g, "%2E") : r, J = i && Ae(l) && l.length === 1 ? ne + "[]" : ne;
  if (a && Ae(l) && l.length === 0)
    return J + "[]";
  for (var se = 0; se < X.length; ++se) {
    var ce = X[se], xe = typeof ce == "object" && typeof ce.value < "u" ? ce.value : l[ce];
    if (!(u && xe === null)) {
      var Ue = T && d ? ce.replace(/\./g, "%2E") : ce, _t = Ae(l) ? typeof n == "function" ? n(J, Ue) : J : J + (T ? "." + Ue : "[" + Ue + "]");
      b.set(e, g);
      var rt = Qa();
      rt.set(wo, b), es(U, t(
        xe,
        _t,
        n,
        i,
        a,
        s,
        u,
        d,
        n === "comma" && x && Ae(l) ? null : p,
        m,
        P,
        T,
        A,
        O,
        E,
        x,
        w,
        rt
      ));
    }
  }
  return U;
}, xp = function(e) {
  if (!e)
    return B;
  if (typeof e.allowEmptyArrays < "u" && typeof e.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof e.encodeDotInKeys < "u" && typeof e.encodeDotInKeys != "boolean")
    throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
  if (e.encoder !== null && typeof e.encoder < "u" && typeof e.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var r = e.charset || B.charset;
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var n = rr.default;
  if (typeof e.format < "u") {
    if (!Pp.call(rr.formatters, e.format))
      throw new TypeError("Unknown format option provided.");
    n = e.format;
  }
  var i = rr.formatters[n], a = B.filter;
  (typeof e.filter == "function" || Ae(e.filter)) && (a = e.filter);
  var s;
  if (e.arrayFormat in qa ? s = e.arrayFormat : "indices" in e ? s = e.indices ? "indices" : "repeat" : s = B.arrayFormat, "commaRoundTrip" in e && typeof e.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var u = typeof e.allowDots > "u" ? e.encodeDotInKeys === !0 ? !0 : B.allowDots : !!e.allowDots;
  return {
    addQueryPrefix: typeof e.addQueryPrefix == "boolean" ? e.addQueryPrefix : B.addQueryPrefix,
    allowDots: u,
    allowEmptyArrays: typeof e.allowEmptyArrays == "boolean" ? !!e.allowEmptyArrays : B.allowEmptyArrays,
    arrayFormat: s,
    charset: r,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : B.charsetSentinel,
    commaRoundTrip: e.commaRoundTrip,
    delimiter: typeof e.delimiter > "u" ? B.delimiter : e.delimiter,
    encode: typeof e.encode == "boolean" ? e.encode : B.encode,
    encodeDotInKeys: typeof e.encodeDotInKeys == "boolean" ? e.encodeDotInKeys : B.encodeDotInKeys,
    encoder: typeof e.encoder == "function" ? e.encoder : B.encoder,
    encodeValuesOnly: typeof e.encodeValuesOnly == "boolean" ? e.encodeValuesOnly : B.encodeValuesOnly,
    filter: a,
    format: n,
    formatter: i,
    serializeDate: typeof e.serializeDate == "function" ? e.serializeDate : B.serializeDate,
    skipNulls: typeof e.skipNulls == "boolean" ? e.skipNulls : B.skipNulls,
    sort: typeof e.sort == "function" ? e.sort : null,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : B.strictNullHandling
  };
}, Mp = function(t, e) {
  var r = t, n = xp(e), i, a;
  typeof n.filter == "function" ? (a = n.filter, r = a("", r)) : Ae(n.filter) && (a = n.filter, i = a);
  var s = [];
  if (typeof r != "object" || r === null)
    return "";
  var u = qa[n.arrayFormat], d = u === "comma" && n.commaRoundTrip;
  i || (i = Object.keys(r)), n.sort && i.sort(n.sort);
  for (var p = Qa(), m = 0; m < i.length; ++m) {
    var P = i[m];
    n.skipNulls && r[P] === null || es(s, Ep(
      r[P],
      P,
      u,
      d,
      n.allowEmptyArrays,
      n.strictNullHandling,
      n.skipNulls,
      n.encodeDotInKeys,
      n.encode ? n.encoder : null,
      n.filter,
      n.sort,
      n.allowDots,
      n.serializeDate,
      n.format,
      n.formatter,
      n.encodeValuesOnly,
      n.charset,
      p
    ));
  }
  var T = s.join(n.delimiter), A = n.addQueryPrefix === !0 ? "?" : "";
  return n.charsetSentinel && (n.charset === "iso-8859-1" ? A += "utf8=%26%2310003%3B&" : A += "utf8=%E2%9C%93&"), T.length > 0 ? A + T : "";
}, Pt = Ya, Lo = Object.prototype.hasOwnProperty, _p = Array.isArray, Z = {
  allowDots: !1,
  allowEmptyArrays: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decodeDotInKeys: !0,
  decoder: Pt.decode,
  delimiter: "&",
  depth: 5,
  duplicates: "combine",
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, Cp = function(t) {
  return t.replace(/&#(\d+);/g, function(e, r) {
    return String.fromCharCode(parseInt(r, 10));
  });
}, ts = function(t, e) {
  return t && typeof t == "string" && e.comma && t.indexOf(",") > -1 ? t.split(",") : t;
}, Np = "utf8=%26%2310003%3B", Ip = "utf8=%E2%9C%93", Dp = function(e, r) {
  var n = { __proto__: null }, i = r.ignoreQueryPrefix ? e.replace(/^\?/, "") : e, a = r.parameterLimit === 1 / 0 ? void 0 : r.parameterLimit, s = i.split(r.delimiter, a), u = -1, d, p = r.charset;
  if (r.charsetSentinel)
    for (d = 0; d < s.length; ++d)
      s[d].indexOf("utf8=") === 0 && (s[d] === Ip ? p = "utf-8" : s[d] === Np && (p = "iso-8859-1"), u = d, d = s.length);
  for (d = 0; d < s.length; ++d)
    if (d !== u) {
      var m = s[d], P = m.indexOf("]="), T = P === -1 ? m.indexOf("=") : P + 1, A, O;
      T === -1 ? (A = r.decoder(m, Z.decoder, p, "key"), O = r.strictNullHandling ? null : "") : (A = r.decoder(m.slice(0, T), Z.decoder, p, "key"), O = Pt.maybeMap(
        ts(m.slice(T + 1), r),
        function(x) {
          return r.decoder(x, Z.decoder, p, "value");
        }
      )), O && r.interpretNumericEntities && p === "iso-8859-1" && (O = Cp(O)), m.indexOf("[]=") > -1 && (O = _p(O) ? [O] : O);
      var E = Lo.call(n, A);
      E && r.duplicates === "combine" ? n[A] = Pt.combine(n[A], O) : (!E || r.duplicates === "last") && (n[A] = O);
    }
  return n;
}, Rp = function(t, e, r, n) {
  for (var i = n ? e : ts(e, r), a = t.length - 1; a >= 0; --a) {
    var s, u = t[a];
    if (u === "[]" && r.parseArrays)
      s = r.allowEmptyArrays && i === "" ? [] : [].concat(i);
    else {
      s = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var d = u.charAt(0) === "[" && u.charAt(u.length - 1) === "]" ? u.slice(1, -1) : u, p = r.decodeDotInKeys ? d.replace(/%2E/g, ".") : d, m = parseInt(p, 10);
      !r.parseArrays && p === "" ? s = { 0: i } : !isNaN(m) && u !== p && String(m) === p && m >= 0 && r.parseArrays && m <= r.arrayLimit ? (s = [], s[m] = i) : p !== "__proto__" && (s[p] = i);
    }
    i = s;
  }
  return i;
}, Lp = function(e, r, n, i) {
  if (e) {
    var a = n.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e, s = /(\[[^[\]]*])/, u = /(\[[^[\]]*])/g, d = n.depth > 0 && s.exec(a), p = d ? a.slice(0, d.index) : a, m = [];
    if (p) {
      if (!n.plainObjects && Lo.call(Object.prototype, p) && !n.allowPrototypes)
        return;
      m.push(p);
    }
    for (var P = 0; n.depth > 0 && (d = u.exec(a)) !== null && P < n.depth; ) {
      if (P += 1, !n.plainObjects && Lo.call(Object.prototype, d[1].slice(1, -1)) && !n.allowPrototypes)
        return;
      m.push(d[1]);
    }
    return d && m.push("[" + a.slice(d.index) + "]"), Rp(m, r, n, i);
  }
}, jp = function(e) {
  if (!e)
    return Z;
  if (typeof e.allowEmptyArrays < "u" && typeof e.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof e.decodeDotInKeys < "u" && typeof e.decodeDotInKeys != "boolean")
    throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
  if (e.decoder !== null && typeof e.decoder < "u" && typeof e.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var r = typeof e.charset > "u" ? Z.charset : e.charset, n = typeof e.duplicates > "u" ? Z.duplicates : e.duplicates;
  if (n !== "combine" && n !== "first" && n !== "last")
    throw new TypeError("The duplicates option must be either combine, first, or last");
  var i = typeof e.allowDots > "u" ? e.decodeDotInKeys === !0 ? !0 : Z.allowDots : !!e.allowDots;
  return {
    allowDots: i,
    allowEmptyArrays: typeof e.allowEmptyArrays == "boolean" ? !!e.allowEmptyArrays : Z.allowEmptyArrays,
    allowPrototypes: typeof e.allowPrototypes == "boolean" ? e.allowPrototypes : Z.allowPrototypes,
    allowSparse: typeof e.allowSparse == "boolean" ? e.allowSparse : Z.allowSparse,
    arrayLimit: typeof e.arrayLimit == "number" ? e.arrayLimit : Z.arrayLimit,
    charset: r,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : Z.charsetSentinel,
    comma: typeof e.comma == "boolean" ? e.comma : Z.comma,
    decodeDotInKeys: typeof e.decodeDotInKeys == "boolean" ? e.decodeDotInKeys : Z.decodeDotInKeys,
    decoder: typeof e.decoder == "function" ? e.decoder : Z.decoder,
    delimiter: typeof e.delimiter == "string" || Pt.isRegExp(e.delimiter) ? e.delimiter : Z.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof e.depth == "number" || e.depth === !1 ? +e.depth : Z.depth,
    duplicates: n,
    ignoreQueryPrefix: e.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof e.interpretNumericEntities == "boolean" ? e.interpretNumericEntities : Z.interpretNumericEntities,
    parameterLimit: typeof e.parameterLimit == "number" ? e.parameterLimit : Z.parameterLimit,
    parseArrays: e.parseArrays !== !1,
    plainObjects: typeof e.plainObjects == "boolean" ? e.plainObjects : Z.plainObjects,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : Z.strictNullHandling
  };
}, Kp = function(t, e) {
  var r = jp(e);
  if (t === "" || t === null || typeof t > "u")
    return r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var n = typeof t == "string" ? Dp(t, r) : t, i = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, a = Object.keys(n), s = 0; s < a.length; ++s) {
    var u = a[s], d = Lp(u, n[u], r, typeof t == "string");
    i = Pt.merge(i, d, r);
  }
  return r.allowSparse === !0 ? i : Pt.compact(i);
}, Fp = Mp, Up = Kp, Gp = qo, Zp = {
  formats: Gp,
  parse: Up,
  stringify: Fp
};
const zp = /* @__PURE__ */ Ot(Zp);
let Le = /* @__PURE__ */ new Map();
function Bi(t, e) {
  const { cancelRequest: r, includeParams: n } = e || {};
  if (!r)
    return;
  const { method: i, url: a, params: s } = t;
  if (n) {
    let u = s;
    return n instanceof Array && (u = n.reduce((d, p) => (d[p] = s[p], d), {})), [i, a, zp.stringify(u)].join("&");
  }
  return [i, a].join("&");
}
class Hp {
  addPending(e, r) {
    this.removePending(e, r);
    const n = Bi(e, r);
    n && (e.cancelToken = e.cancelToken || new G.CancelToken((i) => {
      Le.has(n) || Le.set(n, i);
    }));
  }
  removePending(e, r) {
    const n = Bi(e, r);
    if (n && Le.has(n)) {
      const i = Le.get(n);
      i && i(), Le.delete(n);
    }
  }
  removeAllPending() {
    Le.forEach((e) => {
      typeof e == "function" && e();
    }), Le.clear();
  }
  reset() {
    Le = /* @__PURE__ */ new Map();
  }
}
var Bp = Object.defineProperty, Xp = (t, e, r) => e in t ? Bp(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Xi = (t, e, r) => (Xp(t, typeof e != "symbol" ? e + "" : e, r), r);
class $p {
  constructor(e) {
    Xi(this, "axiosInstance"), Xi(this, "options"), this.options = e, this.axiosInstance = G.create(e), this.setupInterceptors();
  }
  setupInterceptors() {
    var i;
    const {
      requestInterceptors: e,
      // requestInterceptorsCatch,
      responseInterceptors: r
      // responseInterceptorsCatch,
    } = (i = this.options) == null ? void 0 : i.transform, n = new Hp();
    this.axiosInstance.interceptors.request.use((a) => {
      var s, u, d;
      return (s = a.requestOptions) != null && s.cancelRequest && n.addPending(a, a.requestOptions), (u = this.options) != null && u.serverMode && ((d = a.requestOptions) != null && d.mock) && (a.headers || (a.headers = {})), typeof e == "function" && (a = e(a)), a;
    }, void 0), this.axiosInstance.interceptors.response.use((a) => (a && n.removePending(a.config, a.config.requestOptions), typeof r == "function" && (a = r(a)), a), void 0);
  }
  _beforeEachRequest(e, r) {
    var T, A;
    const { mockUrl: n, serverMode: i } = this.options || {}, { mock: a, apiUrl: s, joinPrefix: u, sysPrefix: d, timeout: p, headers: m } = r;
    if (u && (e.url = `${d || ""}${e.url}`), typeof s == "string" && (e.url = i && a ? `${n}${e.url}` : `${s}${e.url}`), typeof p == "number" && (e.timeout = p), e.headers = {
      ...e.headers,
      ...m
    }, ((T = e.method) == null ? void 0 : T.toUpperCase()) == "GET")
      if (typeof e.params == "object")
        for (const O in e.params) {
          const E = e.params[O];
          typeof E == "string" && (e.params[O] = E.replace(/&/g, "%26").replace(/=/g, "%3D").replace(/\+/g, "%2B"));
        }
      else e.params && console.error("params must be a plain object");
    else
      "data" in e || (e.data = e.params, e.params = void 0);
    const { beforeRequest: P } = ((A = this.options) == null ? void 0 : A.transform) || {};
    return typeof P == "function" && (e = P(e, r)), e;
  }
  get(e, r) {
    return this.request({ ...e, method: "GET" }, r);
  }
  post(e, r) {
    return this.request({ ...e, method: "POST" }, r);
  }
  request(e, r) {
    var u, d;
    let n = ls(e);
    const i = { ...(u = this.options) == null ? void 0 : u.requestOptions, ...r };
    this._beforeEachRequest(n, i), n.requestOptions = i;
    const { transformResponse: a, responseCatch: s } = ((d = this.options) == null ? void 0 : d.transform) || {};
    return this.axiosInstance.request(n).then((p) => {
      if (i.returnNativeResponse)
        return p;
      if (!i.needTransformResponse)
        return p == null ? void 0 : p.data;
      if (!p || p.status !== 200 || !p.data)
        throw new Error("HTTP Exception");
      if (typeof a == "function")
        try {
          return a(p, i);
        } catch (m) {
          return typeof s == "function" && s(m, i), p;
        }
      return p;
    }).catch((p) => {
      var m;
      if (G.isCancel(p))
        return console.log("Axios Request has been canceled", p), p;
      if (typeof s == "function" && s(p, i), (m = this.options) != null && m.throwCatch)
        throw new Error(p);
      return p;
    });
  }
}
var kp = /* @__PURE__ */ ((t) => (t.GET = "GET", t.POST = "POST", t))(kp || {}), Wp = /* @__PURE__ */ ((t) => (t.JSON = "application/json;charset=UTF-8", t.FORM_URLENCODED = "application/x-www-form-urlencoded;charset=UTF-8", t.FORM_DATA = "multipart/form-data;charset=UTF-8", t))(Wp || {});
function _h(t, e = { successCode: 200 }) {
  t.transform || (t.transform = {});
  const r = t.transform;
  r.transformResponse = (a) => {
    if ("data" in a && "data" in a.data && "code" in a.data && a.data.code === e.successCode)
      return a.data.data;
    throw a;
  };
  const n = new $p(t);
  function i(a, s) {
    const u = a;
    return u.method === "GET" && u.data && (u.params = u.data), u.method === "POST" && !u.data && (u.data = {}), n.request(a, s);
  }
  return i;
}
const rs = [
  {
    oss: "mogic-algo-data.oss-cn-hangzhou.aliyuncs.com",
    cdn: "mogic-algo-data.getmogic.com",
    bucket: "mogic-algo-data"
  },
  {
    oss: "mogic-spider.oss-cn-hangzhou.aliyuncs.com",
    cdn: "mogic-spider.getmogic.com",
    bucket: "mogic-spider"
  },
  {
    oss: "mogic-creative.oss-cn-hangzhou.aliyuncs.com",
    cdn: "creative-alloss.getmogic.com",
    bucket: "mogic-creative"
  },
  {
    oss: "mogic-effect-test.oss-cn-hangzhou.aliyuncs.com",
    cdn: "mogic-effect-test-cdn.getmogic.com",
    bucket: "mogic-effect-test"
  },
  {
    oss: "mogic-nlp.oss-cn-hangzhou.aliyuncs.com",
    cdn: "mogic-nlp.getmogic.com",
    bucket: "mogic-nlp"
  },
  {
    oss: "mogic-models.oss-cn-hangzhou.aliyuncs.com",
    cdn: "mogic-models.getmogic.com",
    bucket: "mogic-models"
  },
  {
    oss: "fonts-cmp-2-0.oss-cn-hangzhou.aliyuncs.com",
    cdn: "fonts-cmp-2-0.getmogic.com",
    bucket: "fonts-cmp-2-0"
  },
  {
    oss: "mogic-creative.oss-cn-hangzhou.aliyuncs.com",
    cdn: "creative-alloss.getmogic.com",
    bucket: "fonts-cmp-2-0"
  }
], Ch = (t) => {
  if (!t)
    return t;
  try {
    const e = new URL(t), r = rs.find((n) => e.host === n.oss);
    return r ? t.replace(r.oss, r.cdn) : t;
  } catch {
    return t;
  }
}, Nh = (t) => {
  if (!t)
    return t;
  try {
    const e = new URL(t), r = rs.find((n) => e.host === n.cdn);
    return r ? t.replace(r.cdn, r.oss) : t;
  } catch {
    return t;
  }
};
function Vp(t) {
  return t !== null && typeof t == "object";
}
const $i = {
  debug: -1,
  log: 0,
  info: 0,
  warn: 1,
  error: 2
}, ki = [
  "#daa569",
  "#00ffff",
  "#385e0f",
  "#7fffd4",
  "#00c957",
  "#b0e0e6",
  "#4169e1",
  "#6a5acd",
  "#87ceeb",
  "#ffff00",
  "#e3cf57",
  "#ff9912",
  "#eb8e55",
  "#ffe384",
  "#40e0d0",
  "#a39480",
  "#d2691e",
  "#ff7d40",
  "#f0e68c",
  "#bc8f8f",
  "#c76114",
  "#734a12",
  "#5e2612",
  "#0000ff",
  "#3d59ab",
  "#1e90ff",
  "#03a89e",
  "#33a1c9",
  "#a020f0",
  "#a066d3",
  "#da70d6",
  "#dda0dd",
  "#688e23",
  "#2e8b57"
], Jp = {
  debug: "#666666",
  log: "#bbbbbb",
  info: "#ffffff",
  warn: "#bbbbbb",
  error: "#bbbbbb"
}, Yp = {
  debug: "debug",
  log: "log",
  info: "info",
  warn: "warn",
  error: "error"
}, Qp = {
  debug: console.log,
  log: console.log,
  info: console.log,
  warn: console.warn,
  error: console.error
}, Ur = {}, Yt = (t, e = "warn", r, n) => {
  const i = $i[e] <= $i[t], a = n === "*" || r.includes(n);
  return i && a;
}, qp = (t) => {
  if (!Ur[t]) {
    const e = ki[Object.keys(Ur).length % ki.length];
    Ur[t] = e;
  }
  return Ur[t];
}, ed = (t, e, r) => {
  const n = qp(e), i = Jp[r], a = t[0];
  let s = `%c[${e}]%c[${Yp[r]}]:`;
  a.forEach((d) => {
    Vp(d) ? s += "%o" : s += "%s";
  });
  let u = [s, `color: ${n}`, `color: ${i}`];
  return u = u.concat(a), u;
}, Qt = (t, e) => (...r) => Qp[t].apply(console, ed(r, e, t)), td = {
  level: "warn",
  bizName: "*"
};
class rd {
  constructor(e) {
    re(this, "bizName");
    re(this, "targetBizName");
    re(this, "targetLevel");
    e = { ...td, ...e };
    const r = e;
    this.bizName = e.bizName, this.targetBizName = r.bizName, this.targetLevel = r.level;
  }
  debug(...e) {
    if (Yt("debug", this.targetLevel, this.bizName, this.targetBizName))
      return Qt("debug", this.bizName)(e);
  }
  log(...e) {
    if (Yt("log", this.targetLevel, this.bizName, this.targetBizName))
      return Qt("log", this.bizName)(e);
  }
  info(...e) {
    if (Yt("info", this.targetLevel, this.bizName, this.targetBizName))
      return Qt("info", this.bizName)(e);
  }
  warn(...e) {
    if (Yt("warn", this.targetLevel, this.bizName, this.targetBizName))
      return Qt("warn", this.bizName)(e);
  }
  error(...e) {
    if (Yt("error", this.targetLevel, this.bizName, this.targetBizName))
      return Qt("error", this.bizName)(e);
  }
}
const le = new rd({
  level: "log",
  bizName: "oss"
});
function nd(t) {
  if (typeof document < "u" && typeof window < "u" && typeof document.createElement == "function")
    return od(t);
}
const Wi = /* @__PURE__ */ new Set();
function od(t) {
  return new Promise((e, r) => {
    if (typeof t != "string" || !t.length)
      return le.log({
        name: "MogicUtil",
        message: "Invalid Script Url",
        fileName: t
      }), r();
    if (Wi.has(t))
      return e();
    const n = document.createElement("script");
    n.setAttribute("src", t), n.setAttribute("data-namespace", t), n.onload = () => {
      e();
    }, n.onerror = () => {
      le.log({
        name: "MogicUtil",
        message: "Script Load Error",
        fileName: t
      }), r();
    }, Wi.add(t), document.body.appendChild(n);
  });
}
function Vi(t) {
  return typeof t == "string";
}
const id = {
  endpoint: "oss-accelerate.aliyuncs.com",
  // instance level timeout for all operations, SDK 默认 1min
  timeout: 2 * 60 * 1e3,
  // 2min
  // retry when request error is net error or timeout, SDK 默认 0
  maxRetryTimes: 2,
  // SDK 默认 5min
  refreshInterval: 30 * 60 * 1e3,
  // 30min
  // 以上是OSS instance的配置
  // 设置并发上传的分片数量;
  parallel: 4,
  // 设置分片大小 0.5M; SDK 默认值为 1 MB，最小值为 100 KB
  partSize: 1024 * 1024,
  // 分片断点 15 MB; SDK 建议 100M
  partLimit: 15 * 1024 * 1024,
  // 简单上传的虚拟进度条
  fakeProgress: !1,
  // 业务指定的SDK地址，通过 script 加载
  sdkUrl: "https://creative-oss.getmogic.com/static/aliyun-oss-sdk-6.17.1.min.js"
}, bt = class bt {
  constructor() {
    re(this, "ossClient");
    re(this, "getOssClientPromise");
    re(this, "credentials", {});
    re(this, "options");
    // 多文件的断点
    re(this, "checkpoints", {});
    // 缓存需要进度条的简单上传列表
    re(this, "progressListInSimpleMode", []);
    //
    re(this, "progressTimer");
    this.options = {};
  }
  setOptions(e = {}) {
    this.options = {
      ...id,
      ...e
    }, bt.bindNetwork();
  }
  // ---- 初始化OSS客户端 ----
  initAliOSSClient() {
    return new Promise(async (e, r) => {
      var n, i, a, s;
      if (!this.options.getOssAccessKey)
        throw new Error("getOssAccessKey is required");
      try {
        const [u] = await Promise.all([
          this.options.getOssAccessKey(),
          nd(this.options.sdkUrl)
        ]);
        if (!u)
          throw le.log({
            name: "UploadOSS",
            message: `Fetch STS Error${JSON.stringify(u)}`
          }), u;
        this.credentials = u || {};
        const { accessKeyId: d, accessKeySecret: p, securityToken: m, bucketName: P, endpoint: T } = u || {};
        this.ossClient = new OSS({
          accessKeyId: d,
          accessKeySecret: p,
          stsToken: m,
          bucket: P,
          timeout: (n = this.options) == null ? void 0 : n.timeout,
          retryMax: (i = this.options) == null ? void 0 : i.maxRetryTimes,
          endpoint: T || ((a = this.options) == null ? void 0 : a.endpoint),
          refreshSTSTokenInterval: (s = this.options) == null ? void 0 : s.refreshInterval,
          refreshSTSToken: async () => {
            if (!this.options.getOssAccessKey)
              throw new Error("getOssAccessKey is required");
            const A = await this.options.getOssAccessKey();
            if (!A) {
              try {
                le.log({
                  name: "UploadOSS",
                  message: `Refresh STS Error${JSON.stringify(A)}`
                });
              } catch (w) {
                console.log(w);
              }
              return {};
            }
            this.credentials = A || {};
            const { accessKeyId: O, accessKeySecret: E, securityToken: x } = A || {};
            return { accessKeyId: O, accessKeySecret: E, securityToken: x };
          }
        }), e();
      } catch (u) {
        console.log(u), this.getOssClientPromise = void 0, r(`Fetch STS Error${JSON.stringify(u)}`);
      }
    });
  }
  async ensureOSSClient() {
    var e;
    if (!((e = this.options) != null && e.sdkUrl))
      return le.log({
        name: "UploadOSS",
        message: "SDK URL is required"
      }), console.warn("SDK URL is required");
    this.ossClient || (this.getOssClientPromise || (this.getOssClientPromise = this.initAliOSSClient()), await this.getOssClientPromise);
  }
  // ---- 上传回调 ----
  onBeforeLoad(e) {
    typeof e.onBeforeLoad == "function" && e.onBeforeLoad();
  }
  onProgress(e, r) {
    typeof r.onProgress == "function" && r.onProgress(e);
  }
  onComplete(e, r) {
    typeof r.onComplete == "function" && r.onComplete(e);
  }
  onError(e, r) {
    typeof r.onError == "function" && r.onError(e);
  }
  // ---- 前端模拟进度 ----
  add2ProgressList(e) {
    this.progressListInSimpleMode.push({ resource: e, timestamp: Date.now(), fakeSize: 0 });
  }
  removeFromProgressList(e) {
    this.progressListInSimpleMode = this.progressListInSimpleMode.filter((r) => r.resource.id !== e.id);
  }
  // 无脑上传单个文件，内部自动判断是简单、分片
  autoUpload(e) {
    const { file: r } = e;
    console.log(r.size, this.options), r.size > (this.options.partLimit || 0) ? this.partUpload(e) : this.simpleUpload(e);
  }
  uploadFile(e, r, n) {
    return new Promise((i, a) => {
      this.autoUpload({
        file: e,
        customPath: n,
        onComplete: async (s) => {
          i(s.url);
        },
        onProgress: r,
        onError: (s) => {
          a(s);
        }
      });
    });
  }
  // --- case 1 简单上传
  async simpleUpload(e) {
    var s, u, d;
    console.log("simple upload"), le.log({
      name: "UploadOSS",
      message: "SimpleUploadStart",
      fileName: (s = e.file) == null ? void 0 : s.name
    }), this.onBeforeLoad(e);
    try {
      await this.ensureOSSClient();
    } catch (p) {
      this.onError(p, e);
      return;
    }
    (u = this.options) != null && u.fakeProgress && (this.add2ProgressList(e), this.progressTimer || (this.progressTimer = setInterval(() => {
      if (!this.progressListInSimpleMode.length)
        return this.clearProgressTimer();
      this.progressListInSimpleMode.forEach((p) => {
        p.fakeSize += bt.uploadSpeedBPS * (Date.now() - p.timestamp) / 1024;
        const m = Math.min(99, Math.floor(p.fakeSize / p.resource.file.size * 100));
        this.onProgress(m, p.resource), p.timestamp = Date.now(), m >= 99 && this.removeFromProgressList(p.resource);
      });
    }, 120)));
    const { file: r, customPath: n } = e || {}, i = ((d = this.credentials) == null ? void 0 : d.dir) || "", a = n || this.createFileName(r.name, r == null ? void 0 : r.uid);
    return this.ossClient.put(i + a, r).then(() => {
      const m = { url: `${this.credentials.host}/${i}${a}`, file: r };
      return this.removeFromProgressList(e), this.onComplete(m, e), m;
    }).catch((p) => {
      var m;
      console.log("SimpleUploadError", p, e), this.removeFromProgressList(e);
      try {
        le.log({
          name: "UploadOSS",
          message: `SimpleUploadError - ${Vi(p) ? p : JSON.stringify(p)}`,
          fileName: (m = e.file) == null ? void 0 : m.name
        });
      } catch (P) {
        console.log(P);
      }
      this.onError(p, e);
    });
  }
  // --- case 2 分片上传
  async partUpload(e) {
    var r;
    console.log("part upload"), le.log({
      name: "UploadOSS",
      message: "PartUploadStart",
      fileName: (r = e.file) == null ? void 0 : r.name
    }), this.onBeforeLoad(e);
    try {
      await this.ensureOSSClient();
    } catch (n) {
      this.onError(n, e);
      return;
    }
    this.startPartUpload(e);
  }
  startPartUpload(e) {
    var u;
    const { file: r, _uniqueName: n, customPath: i } = e, a = ((u = this.credentials) == null ? void 0 : u.dir) || "", s = i || this.createFileName(r.name, r == null ? void 0 : r.uid);
    return e._uniqueName = n || a + s, this.ossClient.multipartUpload(e._uniqueName, r, {
      parallel: this.options.parallel,
      partSize: this.options.partSize,
      progress: (d, p) => {
        this.onProgress(Math.floor(d * 100), e), p && (this.checkpoints[p.uploadId] = p, e._cptUploadId = p.uploadId);
      },
      // 设置MIME
      ...this.options.partMIME ? { mime: this.options.partMIME } : null,
      // 设置断点
      ...e._cptUploadId && this.checkpoints[e._cptUploadId] ? { checkpoint: this.checkpoints[e._cptUploadId] } : null
    }).then(() => {
      const p = { url: `${this.credentials.host}/${a}${s}`, file: r };
      return this.onComplete(p, e), p;
    }).catch(async (d) => {
      var p;
      console.log("PartUploadError", d, e), le.log({
        name: "UploadOSS",
        message: `PartUploadError - ${Vi(d) ? d : JSON.stringify(d)}`,
        fileName: (p = e.file) == null ? void 0 : p.name
      }), this.abortPartUpload(e), this.onError(d, e);
    });
  }
  // case 3 暂停续传
  abortPartUpload(e) {
    var n, i;
    if (!(e != null && e._uniqueName))
      return;
    const r = (n = (e == null ? void 0 : e._cptUploadId) && this.checkpoints[e._cptUploadId]) == null ? void 0 : n.uploadId;
    if (!r) {
      le.log({
        name: "UploadOSS",
        message: "AbortPartUpload",
        fileName: (i = e.file) == null ? void 0 : i.name
      });
      return;
    }
    try {
      this.ossClient.abortMultipartUpload(e == null ? void 0 : e._uniqueName, r);
    } catch (a) {
      console.log(a);
    }
  }
  createFileName(e, r) {
    return `${r || Date.now() + parseInt(`${Math.random() * 1e6}`, 10)}.${e.substring(e.lastIndexOf(".") + 1)}`;
  }
  destroy() {
    var e;
    le.log("destroy oss client", this.ossClient), (e = this.ossClient) == null || e.cancel(), this.ossClient = null, this.credentials = {}, this.checkpoints = {}, this.clearProgressTimer();
  }
  clearProgressTimer() {
    this.progressTimer && clearInterval(this.progressTimer), this.progressTimer = void 0, this.progressListInSimpleMode = [];
  }
  // https://googlechrome.github.io/samples/network-information/
  static bindNetwork() {
    const e = navigator == null ? void 0 : navigator.connection;
    if (!(e != null && e.downlink)) {
      le.log({
        name: "UploadOSS",
        message: "navigation.connection is not supported"
      });
      return;
    }
    e.addEventListener("change", r);
    function r() {
      bt.uploadSpeedBPS = e.downlink * 1024 * 1024 / 8;
    }
    r();
  }
};
// 简单上传, 上行速度默认值
re(bt, "uploadSpeedBPS", 10 * 1024 * 1024);
let jo = bt;
const Ih = tt() && new jo();
var ns = { exports: {} };
(function(t, e) {
  (function(r) {
    t.exports = r();
  })(function(r) {
    var n = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    function i(w, b) {
      var l = w[0], f = w[1], g = w[2], h = w[3];
      l += (f & g | ~f & h) + b[0] - 680876936 | 0, l = (l << 7 | l >>> 25) + f | 0, h += (l & f | ~l & g) + b[1] - 389564586 | 0, h = (h << 12 | h >>> 20) + l | 0, g += (h & l | ~h & f) + b[2] + 606105819 | 0, g = (g << 17 | g >>> 15) + h | 0, f += (g & h | ~g & l) + b[3] - 1044525330 | 0, f = (f << 22 | f >>> 10) + g | 0, l += (f & g | ~f & h) + b[4] - 176418897 | 0, l = (l << 7 | l >>> 25) + f | 0, h += (l & f | ~l & g) + b[5] + 1200080426 | 0, h = (h << 12 | h >>> 20) + l | 0, g += (h & l | ~h & f) + b[6] - 1473231341 | 0, g = (g << 17 | g >>> 15) + h | 0, f += (g & h | ~g & l) + b[7] - 45705983 | 0, f = (f << 22 | f >>> 10) + g | 0, l += (f & g | ~f & h) + b[8] + 1770035416 | 0, l = (l << 7 | l >>> 25) + f | 0, h += (l & f | ~l & g) + b[9] - 1958414417 | 0, h = (h << 12 | h >>> 20) + l | 0, g += (h & l | ~h & f) + b[10] - 42063 | 0, g = (g << 17 | g >>> 15) + h | 0, f += (g & h | ~g & l) + b[11] - 1990404162 | 0, f = (f << 22 | f >>> 10) + g | 0, l += (f & g | ~f & h) + b[12] + 1804603682 | 0, l = (l << 7 | l >>> 25) + f | 0, h += (l & f | ~l & g) + b[13] - 40341101 | 0, h = (h << 12 | h >>> 20) + l | 0, g += (h & l | ~h & f) + b[14] - 1502002290 | 0, g = (g << 17 | g >>> 15) + h | 0, f += (g & h | ~g & l) + b[15] + 1236535329 | 0, f = (f << 22 | f >>> 10) + g | 0, l += (f & h | g & ~h) + b[1] - 165796510 | 0, l = (l << 5 | l >>> 27) + f | 0, h += (l & g | f & ~g) + b[6] - 1069501632 | 0, h = (h << 9 | h >>> 23) + l | 0, g += (h & f | l & ~f) + b[11] + 643717713 | 0, g = (g << 14 | g >>> 18) + h | 0, f += (g & l | h & ~l) + b[0] - 373897302 | 0, f = (f << 20 | f >>> 12) + g | 0, l += (f & h | g & ~h) + b[5] - 701558691 | 0, l = (l << 5 | l >>> 27) + f | 0, h += (l & g | f & ~g) + b[10] + 38016083 | 0, h = (h << 9 | h >>> 23) + l | 0, g += (h & f | l & ~f) + b[15] - 660478335 | 0, g = (g << 14 | g >>> 18) + h | 0, f += (g & l | h & ~l) + b[4] - 405537848 | 0, f = (f << 20 | f >>> 12) + g | 0, l += (f & h | g & ~h) + b[9] + 568446438 | 0, l = (l << 5 | l >>> 27) + f | 0, h += (l & g | f & ~g) + b[14] - 1019803690 | 0, h = (h << 9 | h >>> 23) + l | 0, g += (h & f | l & ~f) + b[3] - 187363961 | 0, g = (g << 14 | g >>> 18) + h | 0, f += (g & l | h & ~l) + b[8] + 1163531501 | 0, f = (f << 20 | f >>> 12) + g | 0, l += (f & h | g & ~h) + b[13] - 1444681467 | 0, l = (l << 5 | l >>> 27) + f | 0, h += (l & g | f & ~g) + b[2] - 51403784 | 0, h = (h << 9 | h >>> 23) + l | 0, g += (h & f | l & ~f) + b[7] + 1735328473 | 0, g = (g << 14 | g >>> 18) + h | 0, f += (g & l | h & ~l) + b[12] - 1926607734 | 0, f = (f << 20 | f >>> 12) + g | 0, l += (f ^ g ^ h) + b[5] - 378558 | 0, l = (l << 4 | l >>> 28) + f | 0, h += (l ^ f ^ g) + b[8] - 2022574463 | 0, h = (h << 11 | h >>> 21) + l | 0, g += (h ^ l ^ f) + b[11] + 1839030562 | 0, g = (g << 16 | g >>> 16) + h | 0, f += (g ^ h ^ l) + b[14] - 35309556 | 0, f = (f << 23 | f >>> 9) + g | 0, l += (f ^ g ^ h) + b[1] - 1530992060 | 0, l = (l << 4 | l >>> 28) + f | 0, h += (l ^ f ^ g) + b[4] + 1272893353 | 0, h = (h << 11 | h >>> 21) + l | 0, g += (h ^ l ^ f) + b[7] - 155497632 | 0, g = (g << 16 | g >>> 16) + h | 0, f += (g ^ h ^ l) + b[10] - 1094730640 | 0, f = (f << 23 | f >>> 9) + g | 0, l += (f ^ g ^ h) + b[13] + 681279174 | 0, l = (l << 4 | l >>> 28) + f | 0, h += (l ^ f ^ g) + b[0] - 358537222 | 0, h = (h << 11 | h >>> 21) + l | 0, g += (h ^ l ^ f) + b[3] - 722521979 | 0, g = (g << 16 | g >>> 16) + h | 0, f += (g ^ h ^ l) + b[6] + 76029189 | 0, f = (f << 23 | f >>> 9) + g | 0, l += (f ^ g ^ h) + b[9] - 640364487 | 0, l = (l << 4 | l >>> 28) + f | 0, h += (l ^ f ^ g) + b[12] - 421815835 | 0, h = (h << 11 | h >>> 21) + l | 0, g += (h ^ l ^ f) + b[15] + 530742520 | 0, g = (g << 16 | g >>> 16) + h | 0, f += (g ^ h ^ l) + b[2] - 995338651 | 0, f = (f << 23 | f >>> 9) + g | 0, l += (g ^ (f | ~h)) + b[0] - 198630844 | 0, l = (l << 6 | l >>> 26) + f | 0, h += (f ^ (l | ~g)) + b[7] + 1126891415 | 0, h = (h << 10 | h >>> 22) + l | 0, g += (l ^ (h | ~f)) + b[14] - 1416354905 | 0, g = (g << 15 | g >>> 17) + h | 0, f += (h ^ (g | ~l)) + b[5] - 57434055 | 0, f = (f << 21 | f >>> 11) + g | 0, l += (g ^ (f | ~h)) + b[12] + 1700485571 | 0, l = (l << 6 | l >>> 26) + f | 0, h += (f ^ (l | ~g)) + b[3] - 1894986606 | 0, h = (h << 10 | h >>> 22) + l | 0, g += (l ^ (h | ~f)) + b[10] - 1051523 | 0, g = (g << 15 | g >>> 17) + h | 0, f += (h ^ (g | ~l)) + b[1] - 2054922799 | 0, f = (f << 21 | f >>> 11) + g | 0, l += (g ^ (f | ~h)) + b[8] + 1873313359 | 0, l = (l << 6 | l >>> 26) + f | 0, h += (f ^ (l | ~g)) + b[15] - 30611744 | 0, h = (h << 10 | h >>> 22) + l | 0, g += (l ^ (h | ~f)) + b[6] - 1560198380 | 0, g = (g << 15 | g >>> 17) + h | 0, f += (h ^ (g | ~l)) + b[13] + 1309151649 | 0, f = (f << 21 | f >>> 11) + g | 0, l += (g ^ (f | ~h)) + b[4] - 145523070 | 0, l = (l << 6 | l >>> 26) + f | 0, h += (f ^ (l | ~g)) + b[11] - 1120210379 | 0, h = (h << 10 | h >>> 22) + l | 0, g += (l ^ (h | ~f)) + b[2] + 718787259 | 0, g = (g << 15 | g >>> 17) + h | 0, f += (h ^ (g | ~l)) + b[9] - 343485551 | 0, f = (f << 21 | f >>> 11) + g | 0, w[0] = l + w[0] | 0, w[1] = f + w[1] | 0, w[2] = g + w[2] | 0, w[3] = h + w[3] | 0;
    }
    function a(w) {
      var b = [], l;
      for (l = 0; l < 64; l += 4)
        b[l >> 2] = w.charCodeAt(l) + (w.charCodeAt(l + 1) << 8) + (w.charCodeAt(l + 2) << 16) + (w.charCodeAt(l + 3) << 24);
      return b;
    }
    function s(w) {
      var b = [], l;
      for (l = 0; l < 64; l += 4)
        b[l >> 2] = w[l] + (w[l + 1] << 8) + (w[l + 2] << 16) + (w[l + 3] << 24);
      return b;
    }
    function u(w) {
      var b = w.length, l = [1732584193, -271733879, -1732584194, 271733878], f, g, h, _, K, U;
      for (f = 64; f <= b; f += 64)
        i(l, a(w.substring(f - 64, f)));
      for (w = w.substring(f - 64), g = w.length, h = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], f = 0; f < g; f += 1)
        h[f >> 2] |= w.charCodeAt(f) << (f % 4 << 3);
      if (h[f >> 2] |= 128 << (f % 4 << 3), f > 55)
        for (i(l, h), f = 0; f < 16; f += 1)
          h[f] = 0;
      return _ = b * 8, _ = _.toString(16).match(/(.*?)(.{0,8})$/), K = parseInt(_[2], 16), U = parseInt(_[1], 16) || 0, h[14] = K, h[15] = U, i(l, h), l;
    }
    function d(w) {
      var b = w.length, l = [1732584193, -271733879, -1732584194, 271733878], f, g, h, _, K, U;
      for (f = 64; f <= b; f += 64)
        i(l, s(w.subarray(f - 64, f)));
      for (w = f - 64 < b ? w.subarray(f - 64) : new Uint8Array(0), g = w.length, h = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], f = 0; f < g; f += 1)
        h[f >> 2] |= w[f] << (f % 4 << 3);
      if (h[f >> 2] |= 128 << (f % 4 << 3), f > 55)
        for (i(l, h), f = 0; f < 16; f += 1)
          h[f] = 0;
      return _ = b * 8, _ = _.toString(16).match(/(.*?)(.{0,8})$/), K = parseInt(_[2], 16), U = parseInt(_[1], 16) || 0, h[14] = K, h[15] = U, i(l, h), l;
    }
    function p(w) {
      var b = "", l;
      for (l = 0; l < 4; l += 1)
        b += n[w >> l * 8 + 4 & 15] + n[w >> l * 8 & 15];
      return b;
    }
    function m(w) {
      var b;
      for (b = 0; b < w.length; b += 1)
        w[b] = p(w[b]);
      return w.join("");
    }
    m(u("hello")), typeof ArrayBuffer < "u" && !ArrayBuffer.prototype.slice && function() {
      function w(b, l) {
        return b = b | 0 || 0, b < 0 ? Math.max(b + l, 0) : Math.min(b, l);
      }
      ArrayBuffer.prototype.slice = function(b, l) {
        var f = this.byteLength, g = w(b, f), h = f, _, K, U, X;
        return l !== r && (h = w(l, f)), g > h ? new ArrayBuffer(0) : (_ = h - g, K = new ArrayBuffer(_), U = new Uint8Array(K), X = new Uint8Array(this, g, _), U.set(X), K);
      };
    }();
    function P(w) {
      return /[\u0080-\uFFFF]/.test(w) && (w = unescape(encodeURIComponent(w))), w;
    }
    function T(w, b) {
      var l = w.length, f = new ArrayBuffer(l), g = new Uint8Array(f), h;
      for (h = 0; h < l; h += 1)
        g[h] = w.charCodeAt(h);
      return b ? g : f;
    }
    function A(w) {
      return String.fromCharCode.apply(null, new Uint8Array(w));
    }
    function O(w, b, l) {
      var f = new Uint8Array(w.byteLength + b.byteLength);
      return f.set(new Uint8Array(w)), f.set(new Uint8Array(b), w.byteLength), f;
    }
    function E(w) {
      var b = [], l = w.length, f;
      for (f = 0; f < l - 1; f += 2)
        b.push(parseInt(w.substr(f, 2), 16));
      return String.fromCharCode.apply(String, b);
    }
    function x() {
      this.reset();
    }
    return x.prototype.append = function(w) {
      return this.appendBinary(P(w)), this;
    }, x.prototype.appendBinary = function(w) {
      this._buff += w, this._length += w.length;
      var b = this._buff.length, l;
      for (l = 64; l <= b; l += 64)
        i(this._hash, a(this._buff.substring(l - 64, l)));
      return this._buff = this._buff.substring(l - 64), this;
    }, x.prototype.end = function(w) {
      var b = this._buff, l = b.length, f, g = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], h;
      for (f = 0; f < l; f += 1)
        g[f >> 2] |= b.charCodeAt(f) << (f % 4 << 3);
      return this._finish(g, l), h = m(this._hash), w && (h = E(h)), this.reset(), h;
    }, x.prototype.reset = function() {
      return this._buff = "", this._length = 0, this._hash = [1732584193, -271733879, -1732584194, 271733878], this;
    }, x.prototype.getState = function() {
      return {
        buff: this._buff,
        length: this._length,
        hash: this._hash.slice()
      };
    }, x.prototype.setState = function(w) {
      return this._buff = w.buff, this._length = w.length, this._hash = w.hash, this;
    }, x.prototype.destroy = function() {
      delete this._hash, delete this._buff, delete this._length;
    }, x.prototype._finish = function(w, b) {
      var l = b, f, g, h;
      if (w[l >> 2] |= 128 << (l % 4 << 3), l > 55)
        for (i(this._hash, w), l = 0; l < 16; l += 1)
          w[l] = 0;
      f = this._length * 8, f = f.toString(16).match(/(.*?)(.{0,8})$/), g = parseInt(f[2], 16), h = parseInt(f[1], 16) || 0, w[14] = g, w[15] = h, i(this._hash, w);
    }, x.hash = function(w, b) {
      return x.hashBinary(P(w), b);
    }, x.hashBinary = function(w, b) {
      var l = u(w), f = m(l);
      return b ? E(f) : f;
    }, x.ArrayBuffer = function() {
      this.reset();
    }, x.ArrayBuffer.prototype.append = function(w) {
      var b = O(this._buff.buffer, w), l = b.length, f;
      for (this._length += w.byteLength, f = 64; f <= l; f += 64)
        i(this._hash, s(b.subarray(f - 64, f)));
      return this._buff = f - 64 < l ? new Uint8Array(b.buffer.slice(f - 64)) : new Uint8Array(0), this;
    }, x.ArrayBuffer.prototype.end = function(w) {
      var b = this._buff, l = b.length, f = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], g, h;
      for (g = 0; g < l; g += 1)
        f[g >> 2] |= b[g] << (g % 4 << 3);
      return this._finish(f, l), h = m(this._hash), w && (h = E(h)), this.reset(), h;
    }, x.ArrayBuffer.prototype.reset = function() {
      return this._buff = new Uint8Array(0), this._length = 0, this._hash = [1732584193, -271733879, -1732584194, 271733878], this;
    }, x.ArrayBuffer.prototype.getState = function() {
      var w = x.prototype.getState.call(this);
      return w.buff = A(w.buff), w;
    }, x.ArrayBuffer.prototype.setState = function(w) {
      return w.buff = T(w.buff, !0), x.prototype.setState.call(this, w);
    }, x.ArrayBuffer.prototype.destroy = x.prototype.destroy, x.ArrayBuffer.prototype._finish = x.prototype._finish, x.ArrayBuffer.hash = function(w, b) {
      var l = d(new Uint8Array(w)), f = m(l);
      return b ? E(f) : f;
    }, x;
  });
})(ns);
var ad = ns.exports;
const sd = /* @__PURE__ */ Ot(ad), cd = 1024 * 1024 * 100;
function Dh(t, e = cd) {
  return new Promise((r, n) => {
    const i = new sd.ArrayBuffer(), a = new FileReader();
    let s = 0;
    function u() {
      const d = s + e;
      a.readAsArrayBuffer(t.slice(s, d)), s = d;
    }
    a.onload = (d) => {
      i.append(d.target.result), s < t.size ? u() : r(i.end());
    }, a.onerror = (d) => n(d), u();
  });
}
const os = "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", ud = (t) => Uint8Array.from(atob(t), (e) => e.charCodeAt(0)), Ji = typeof window < "u" && window.Blob && new Blob([ud(os)], { type: "text/javascript;charset=utf-8" });
function ld(t) {
  let e;
  try {
    if (e = Ji && (window.URL || window.webkitURL).createObjectURL(Ji), !e) throw "";
    const r = new Worker(e, {
      name: t == null ? void 0 : t.name
    });
    return r.addEventListener("error", () => {
      (window.URL || window.webkitURL).revokeObjectURL(e);
    }), r;
  } catch {
    return new Worker(
      "data:text/javascript;base64," + os,
      {
        name: t == null ? void 0 : t.name
      }
    );
  } finally {
    e && (window.URL || window.webkitURL).revokeObjectURL(e);
  }
}
function fd(t, e) {
  return new Promise((r, n) => {
    e.onload = (i) => {
      r(i.target.result);
    }, e.onerror = (i) => n(i), e.readAsArrayBuffer(t);
  });
}
const pd = 1024 * 1024 * 1024, Rh = async (t) => new Promise((e, r) => {
  t.length || e([]);
  const n = /* @__PURE__ */ new Map(), i = new Array(t.length);
  let a = 0;
  const s = new FileReader();
  function u(p, m) {
    i[p] = { file: t[p], md5: m }, a++, a === t.length && (n.forEach((P, T) => T.terminate()), n.clear(), s.onload = null, s.onerror = null, e(i));
  }
  function d(p) {
    const m = t[p];
    if (!m) return;
    let P = Array.from(n.values()).find(({ size: T }) => T + m.size < pd);
    if (!P) {
      const T = new ld(), A = { size: 0 };
      A.post = (O, E) => {
        A.size += O.byteLength, T.postMessage({ i: E, buffer: O }, [O]);
      }, T.onmessage = function({ data: { i: O, md5: E, size: x } }) {
        A.size -= t[O].size, A.size <= 0 && (T.terminate(), n.delete(T)), u(O, E);
      }, n.set(T, P = A);
    }
    fd(m, s).then((T) => P.post(T, p)).catch(() => u(p)).finally(() => d(p + 1));
  }
  d(0);
});
function Lh(t, e) {
  return fetch(t).then((r) => r.blob()).then((r) => {
    const n = window.URL.createObjectURL(r), i = document.createElement("a");
    i.href = n, e && (i.download = e), document.body.appendChild(i), i.click(), URL.revokeObjectURL(n), i.remove();
  });
}
function dd() {
  const t = navigator.userAgent;
  return t.match(/compatible/i) || t.match(/Windows/i) ? "windows" : t.match(/Macintosh/i) || t.match(/MacIntel/i) ? "macOS" : t.match(/iphone/i) || t.match(/Ipad/i) ? "ios" : t.match(/android/i) ? "android" : "unknown OS";
}
function hd() {
  const t = navigator.userAgent, e = [{
    name: "chrome",
    it: t.indexOf("Chrome") > -1 || t.indexOf("CriOS") > -1
  }, {
    name: "firefox",
    it: t.indexOf("Firefox") > -1
  }, {
    name: "safari",
    it: t.indexOf("Safari") > -1 && t.indexOf("Chrome") === -1
  }, {
    name: "opera",
    it: t.indexOf("Opera") > -1 || t.indexOf("OPR") > -1
  }, {
    name: "edge",
    it: t.indexOf("Edge") > -1
  }, {
    name: "ie11",
    it: t.indexOf("Trident") > -1 && t.indexOf("rv:11.0") > -1
  }, {
    name: "ie",
    it: t.indexOf("compatible") > -1 && t.indexOf("MSIE") > -1
  }, {
    name: "wechat",
    it: /MicroMessenger/i.test(t)
  }];
  for (let r = 0; r < e.length; r++)
    if (e[r].it)
      return e[r].name;
  return t;
}
function yd() {
  return window.screen.width + "x" + window.screen.height;
}
function Ko(t) {
  return typeof t == "function";
}
function md(t) {
  if (!Array.isArray(t))
    throw new Error("plugins must be an array");
  if (t != null && t.some((e) => !Ko(e)))
    throw new Error("plugins must be all functions");
  return (e, r, n) => {
    let i = -1;
    const a = async (s, u) => {
      if (s == i)
        throw new Error("next() called multiple times");
      if (s == t.length)
        return n(u);
      i = s;
      const d = t[s];
      await d(e, u, (p) => {
        a(s + 1, p);
      });
    };
    a(0, r);
  };
}
function gd() {
  return "1.0.7";
}
function Gr(t, e) {
  var n, i;
  const r = new XMLHttpRequest();
  r.open("POST", t), r.setRequestHeader("content-type", "application/json"), (n = e == null ? void 0 : e.user) != null && n.token && r.setRequestHeader("X-Access-Token", (i = e == null ? void 0 : e.user) == null ? void 0 : i.token), r.onreadystatechange = () => {
    r.readyState === XMLHttpRequest.DONE && r.status;
  }, r.onerror = (a) => {
    console.warn("mogic-tracker", a);
  }, r.send(JSON.stringify(e));
}
function bd(t, e) {
  const r = (e == null ? void 0 : e.env) || "dev";
  let n = "back.getmogic.com";
  r == "beta" ? n = "c" + n : r == "dev" && (n = "k" + n), e != null && e.useNew ? e != null && e.customHost ? Gr(`${e == null ? void 0 : e.customHost}/creativeSaas/burialPoint/burialLog`, t) : Gr(`https://${n}/creativeSaas/burialPoint/burialLog`, t) : e != null && e.customHost ? Gr(`${e == null ? void 0 : e.customHost}/creativeSaas/burialPoint/recordLog`, t) : Gr(`https://${n}/creativeSaas/burialPoint/recordLog`, t);
}
var qt = /* @__PURE__ */ ((t) => (t.PAGE_SHOW = "pageShow", t.BEHAVIOR = "behavior", t))(qt || {}), wd = Object.defineProperty, Sd = (t, e, r) => e in t ? wd(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Yi = (t, e, r) => (Sd(t, typeof e != "symbol" ? e + "" : e, r), r);
class vd {
  constructor(e) {
    Yi(this, "history"), Yi(this, "opts"), this.history = [], this.opts = {
      maxLength: 2,
      ...e
    };
  }
  record(e) {
    const { title: r, referrer: n } = document, { hash: i, href: a } = window.location, s = /#.*$/;
    let [u, d = ""] = i.split("?") || [];
    u = u.replace(/#/, "");
    const p = a.replace(s, ""), m = d == null ? void 0 : d.split("&").reduce((T, A) => {
      const [O, E] = A.split("=");
      return T[O] = E, T;
    }, /* @__PURE__ */ Object.create(null)), P = {
      title: r,
      url: a,
      hostname: p,
      hash: i,
      query: m,
      queryStr: d,
      path: u
    };
    n && (P.referrer = n), this.add({
      ...P,
      ...e
    });
  }
  add(e) {
    this.history.push(e), this.history.slice(-1 * this.opts.maxLength);
  }
  get last() {
    var e;
    return (e = this.history) != null && e.length ? this.history[this.history.length - 1] : null;
  }
  destroy() {
    this.history = [];
  }
}
var Pd = Object.defineProperty, Od = (t, e, r) => e in t ? Pd(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Qi = (t, e, r) => (Od(t, typeof e != "symbol" ? e + "" : e, r), r);
function Td() {
  class t extends HTMLElement {
    constructor() {
      super(), Qi(this, "_shadowRoot"), Qi(this, "container"), this._shadowRoot = this.attachShadow({ mode: "open" }), this._shadowRoot.appendChild(this.template()), this.container = this._shadowRoot.querySelector("#track-list"), this._shadowRoot.querySelector(".track-me-close").addEventListener(
        "click",
        () => {
          this._shadowRoot.querySelector(".track-me").classList.toggle("hidden");
        },
        !1
      );
    }
    get list() {
      try {
        return JSON.parse(this.getAttribute("data-list"));
      } catch {
      }
    }
    static get observedAttributes() {
      return ["data-list"];
    }
    attributeChangedCallback() {
      this.render();
    }
    addLog(r) {
      const n = this.list || [];
      n.unshift(r), this.setAttribute("data-list", JSON.stringify(n));
    }
    template() {
      const r = document.createElement("template");
      return r.innerHTML = `
        <style>
        .track-me {
          position: fixed;
          z-index: 99999;
          bottom: 0;
          left: 0;
          background: #9ce5c494;
          font-size: 12px;
          padding-right: 5px;
          padding-top: 20px;
        }
        .track-me.hidden {
          transform: translateX(-100%);
        }
        .track-me p {
          padding: 0;
          margin: 0;
        }
        .track-me ul {
          list-style: none;
          padding: 0 8px;
          margin: 0;
          min-width: 240px;
          max-height: 240px;
          overflow-y: scroll;
        }
        .track-me ul::-webkit-scrollbar {
          width: 5px;
          display: block;
        }
        .track-me ul::-webkit-scrollbar-thumb {
          background: rgba(30, 29, 53, 0.11);
          border-radius: 60px;
        }
        .track-me .track-row {
          padding: 6px 4px;
          border-bottom: 1px solid #ffffffa8;
          display: flex;
          justify-content: space-between;
        }
        .track-me .track-row:hover {
          background: #8fecc2;
        }
        .track-me .track-row.error { color: #ed0707; }
        .track-me .track-row.deprecated { color: #bc20ef; }
        .track-me .track-time {
          margin-left: 10px;
        }
        .track-me .track-me-close {
          position: absolute;
          top: 0;
          right: -26px;
          width: 10px;
          background: #d9d9d9;
          padding: 4px 8px;
        }
        </style>
        <div class="track-me">
          <ul id="track-list"></ul>
          <span class="track-me-close">收起</span>
        </div>
      `, r.content.cloneNode(!0);
    }
    formatTime(r) {
      const n = new Date(r);
      return [n.getHours(), n.getMinutes(), n.getSeconds()].map((i) => ("" + i).padStart(2, "0")).join(":");
    }
    render() {
      const r = (this.list || []).map(
        (n) => `
        <li class="track-row ${n.deprecated ? "deprecated" : ""} ${n.valid ? "" : "error"}">
          <div>
            <p>${n.spmId}</p>
            <p>${n.extParam || ""}</p>
          </div>
          <span class="track-time">${this.formatTime(n.timestamp)}</span>
        </li>`
      ).join("");
      this.container.innerHTML = r;
    }
  }
  return t;
}
async function Ad(t) {
  return (await fetch(
    "https://mogic-logger-server.dev.getmogic.com/track/validate",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(t)
    }
  )).json();
}
let mt;
const Ed = async (t, e, r) => {
  customElements.get("track-me") || customElements.define("track-me", Td()), t.options.debug && !mt && (mt = document.createElement("track-me"), document.body.appendChild(mt));
  const {
    type: n,
    eventId: i,
    event_id: a,
    eventFrom: s,
    timestamp: u,
    reportTimestamp: d,
    page: p
  } = e || {}, m = (p == null ? void 0 : p.pageId) || e.pageId || "", [P = "", T = ""] = m == null ? void 0 : m.split(".");
  let A = !0;
  if (t.options.validate)
    try {
      const O = t.options.validate ? await Ad({ appId: P, eventId: i || a }) : await Promise.resolve({ data: !0 });
      A = !!(O != null && O.data);
    } catch {
    }
  mt == null || mt.addLog({
    spmId: [
      n,
      [P, T, i || a, s].filter(Boolean).join(".")
    ].filter(Boolean).join(" | "),
    // extParam: JSON.stringify(params),
    timestamp: u || d,
    valid: A,
    // 新旧sdk提示
    deprecated: !p
  }), (!t.options.validate || A) && r(e);
};
var xd = Object.defineProperty, Md = (t, e, r) => e in t ? xd(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Zr = (t, e, r) => (Md(t, typeof e != "symbol" ? e + "" : e, r), r);
class is {
  constructor(e) {
    Zr(this, "options"), Zr(this, "common"), Zr(this, "pageStack"), Zr(this, "_transform");
    const r = {
      useNew: !0,
      // 默认使用新埋点结构
      ...e
    };
    this.initCommon(r), this.pageStack = new vd(), this.options = r;
    const n = (r == null ? void 0 : r.plugins) || [];
    (r != null && r.debug || r != null && r.validate) && n.unshift(Ed), this._transform = md(n);
  }
  initCommon(e) {
    const { appId: r, appName: n, appVersion: i } = e || {};
    this.common = {
      os: dd(),
      // 系统
      ua: hd(),
      // 浏览器
      sr: yd(),
      // 屏幕分辨率
      appId: r,
      appName: n,
      appVersion: i
    };
  }
  // page 目前也兼容新旧两套版本
  page(e, r = null) {
    this.pageStack.record(e), e != null && e.isNew ? this._report({
      type: qt.PAGE_SHOW,
      isNew: !0
    }) : this._report({
      params: r,
      type: qt.PAGE_SHOW
    });
  }
  track(e, r = null) {
    typeof e == "string" ? this._report({
      type: qt.BEHAVIOR,
      event_id: e,
      params: r
    }) : this._report({
      type: qt.BEHAVIOR,
      eventId: e.eventId,
      eventFrom: e.eventFrom,
      eventTargets: e.eventTargets,
      isNew: !0
    });
  }
  async _report(e) {
    var a, s, u;
    if (!e.type)
      return;
    const r = this.pageStack.last, n = [this.common.appId, r == null ? void 0 : r.pageId].filter(Boolean).join("."), i = {
      common: this.common,
      // 兼容一下
      user: Ko((a = this.options) == null ? void 0 : a.userInfo) ? (s = this.options) == null ? void 0 : s.userInfo() : (u = this.options) == null ? void 0 : u.userInfo,
      type: e.type,
      // 旧版本
      ...e.event_id ? { event_id: e.event_id } : null,
      // 新版本
      ...e.eventId ? { eventId: e.eventId } : null,
      ...e.eventFrom ? { eventFrom: e.eventFrom } : null
    };
    e.isNew ? (i.sdkVersion = gd(), i.page = {
      pageId: n,
      urlParams: (r == null ? void 0 : r.queryStr) || "",
      ...r == null ? void 0 : r.extend
    }, i.events = e.eventTargets || [], i.reportTimestamp = Date.now()) : (i.pageId = n, i.params = e.params, i.timestamp = Date.now()), this._transform(this, i, (d) => {
      var T;
      const { customRequest: p, env: m, useNew: P } = this.options || {};
      if (d && Ko(p)) {
        p(d);
        return;
      }
      bd(d, {
        env: m,
        useNew: P && e.isNew,
        customHost: (T = this.options) == null ? void 0 : T.customHost
      });
    });
  }
  destroy() {
    var e;
    (e = this.pageStack) == null || e.destroy();
  }
}
typeof window < "u" && window.mogicTrackerConfig && (window.mogicTracker = new is(window.mogicTrackerConfig));
function _d() {
  const [t, e = ""] = window.location.href.split("?") || [];
  return e == null ? void 0 : e.split("&").reduce((r, n) => {
    const [i, a] = n.split("=");
    return r[i] = a, r;
  }, {});
}
function jh(t) {
  const e = new is({
    ...t,
    validate: !1,
    debug: t.env === "prod" && !!sessionStorage.getItem("TRACKER_DEBUG")
  });
  function r(i, a) {
    Zo(a) || (a = [a]), e.track({
      eventId: i,
      eventTargets: a.map((s) => {
        const { itemType: u, item: d, extend: p } = s;
        return {
          itemType: u,
          item: d,
          eventTimestamp: Date.now(),
          extend: p
        };
      })
    });
  }
  function n(i, a = {}) {
    e.page({
      ...i,
      url: window.location.href,
      hostname: window.location.hostname,
      isNew: !0,
      extend: {
        ..._d(),
        ...a
      }
    });
  }
  return { track: r, trackPage: n };
}
export {
  Vd as CancelMap,
  Wp as ContentTypeEnum,
  $p as EAxios,
  Zd as IS,
  is as MogicTracker,
  kp as REQUEST_METHOD,
  jo as UploadOSS,
  $c as WebStorage,
  ph as arrayRemoval,
  vh as asStrUnion,
  G as axios,
  Bd as cancelReject,
  Nh as cdn2oss,
  ls as clonedeep,
  uh as convertNumberUnit,
  bh as copy,
  Dh as createFileMd5,
  _h as createRequest,
  Lh as downloadByUrl,
  rh as fileSizeFormat,
  lh as filterTrue,
  eh as formatDate,
  qd as formatTime,
  ch as frame2Second,
  yh as getBusinessConfig,
  Sh as getCanWrite,
  pa as getCancelError,
  kc as getCancelablePromise,
  _d as getCommonDataFromQuery,
  Cc as getComputedStyle,
  Rd as getElementHeight,
  Gd as getElementIntersecting,
  jd as getElementViewOffset,
  Ld as getElementWidth,
  Oh as getEntries,
  gh as getFileNameAndExt,
  Rh as getFilesMd5Arr,
  Jd as getImageInfo,
  Jc as getJson,
  fh as getJsonArrayOrArray,
  Ph as getKeys,
  Dd as getLineHeight,
  Th as getMessagesByModules,
  ah as getPositiveInteger,
  kd as getPromiseState,
  Yd as getQuery,
  Eh as getQueryString,
  jh as getTracker,
  ge as getType,
  dh as getValArr,
  Wc as getValByKey,
  Xd as ignoreCallback,
  Hc as intersectionObserverEnabled,
  Zo as isArray,
  tt as isBrowser,
  Rc as isFunction,
  jc as isMap,
  Xc as isMobile,
  ca as isNull,
  So as isNullOrUndef,
  Dc as isNumber,
  Lc as isObject,
  la as isObjectType,
  Uc as isPromise,
  Bc as isSafari,
  Kc as isSet,
  Ic as isString,
  Fc as isSymbol,
  ua as isUndef,
  Gc as isUrl,
  Nd as isequal,
  vo as judgeCancelError,
  Ud as loadScriptFromRemote,
  Ah as mergeI18nMessage,
  Zc as nativeEllipsisEnabled,
  nh as normalized,
  th as number2Chinese,
  Fd as off,
  Kd as on,
  wh as openNewTab,
  Ch as oss2cdn,
  mh as pauseOtherVideo,
  Hd as promisify,
  hh as pushObjArr,
  xh as resetReactive,
  zc as resizeObserverEnabled,
  ih as rgbStrToArr,
  oh as sec2time,
  sh as second2Frame,
  ro as set,
  Qd as setQuery,
  Mh as setVueProps,
  Wd as sleep,
  Id as throttle,
  Ih as uploadOSSClient,
  zd as webStorage,
  $d as windowsCancelReject
};
